export const FormatsData: {[k: string]: SpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["gigadrain", "leechseed", "sleeppowder", "sludgebomb", "substitute"],
		randomBattleLevel: 82,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	venusaurmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	venusaurgmax: {
		randomDoubleBattleMoves: ["earthpower", "energyball", "leechseed", "protect", "sleeppowder", "sludgebomb"],
		randomDoubleBattleLevel: 80,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["airslash", "earthquake", "fireblast", "focusblast", "roost"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["airslash", "heatwave", "overheat", "protect", "scorchingsands", "tailwind"],
		randomDoubleBattleLevel: 80,
		randomBattleNoDynamaxMoves: ["defog", "earthquake", "fireblast", "hurricane", "roost", "toxic"],
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	charizardmegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	charizardmegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	charizardgmax: {
		randomDoubleBattleMoves: ["airslash", "fireblast", "focusblast", "heatwave", "protect", "tailwind"],
		randomDoubleBattleLevel: 80,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["earthquake", "hydropump", "icebeam", "shellsmash"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["icebeam", "muddywater", "protect", "shellsmash"],
		randomDoubleBattleLevel: 80,
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	blastoisemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	blastoisegmax: {
		randomBattleMoves: ["icebeam", "protect", "rapidspin", "scald", "toxic"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["fakeout", "flipturn", "followme", "icywind", "lifedew", "muddywater"],
		randomDoubleBattleLevel: 80,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["energyball", "hurricane", "quiverdance", "sleeppowder"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["hurricane", "pollenpuff", "protect", "ragepowder", "sleeppowder", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	butterfreegmax: {
		randomBattleMoves: ["airslash", "bugbuzz", "quiverdance", "sleeppowder"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["hurricane", "pollenpuff", "protect", "quiverdance", "sleeppowder"],
		randomDoubleBattleLevel: 88,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	weedle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kakuna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beedrill: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	beedrillmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	pidgey: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pidgeotto: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	pidgeot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pidgeotmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	rattata: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rattataalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	raticate: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	raticatealolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	fearow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ekans: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	arbok: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachu: {
		randomBattleMoves: ["irontail", "knockoff", "surf", "voltswitch", "volttackle"],
		randomBattleLevel: 92,
		randomDoubleBattleMoves: ["fakeout", "grassknot", "knockoff", "protect", "volttackle"],
		randomDoubleBattleLevel: 91,
		tier: "NFE",
	},
	pikachucosplay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachurockstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachubelle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachupopstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuphd: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachulibre: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuoriginal: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachuhoenn: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachusinnoh: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachuunova: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachukalos: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachualola: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachupartner: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pikachustarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	pikachugmax: {
		randomDoubleBattleMoves: ["extremespeed", "fakeout", "knockoff", "surf", "volttackle"],
		randomDoubleBattleLevel: 90,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	pikachuworld: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichu: {
		randomBattleMoves: ["focusblast", "grassknot", "nastyplot", "surf", "thunderbolt", "voltswitch"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["encore", "fakeout", "helpinghand", "nuzzle", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 88,
		randomBattleNoDynamaxMoves: ["encore", "focusblast", "grassknot", "nastyplot", "surf", "thunderbolt", "voltswitch"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raichualola: {
		randomBattleMoves: ["focusblast", "grassknot", "nastyplot", "psyshock", "thunderbolt", "voltswitch"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["focusblast", "nastyplot", "psyshock", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 86,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandshrewalola: {
		tier: "NUBL",
		doublesTier: "LC",
		natDexTier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "knockoff", "rapidspin", "spikes", "stealthrock", "stoneedge", "swordsdance", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["drillrun", "knockoff", "protect", "stealthrock", "stoneedge", "swordsdance"],
		randomDoubleBattleLevel: 89,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandslashalola: {
		randomBattleMoves: ["earthquake", "ironhead", "knockoff", "rapidspin", "swordsdance", "tripleaxel"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["drillrun", "ironhead", "protect", "swordsdance", "tripleaxel"],
		randomDoubleBattleLevel: 90,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["earthpower", "icebeam", "sludgewave", "stealthrock", "toxicspikes"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["earthpower", "icebeam", "protect", "sludgebomb", "stealthrock"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthpower", "icebeam", "sludgewave", "substitute", "superpower"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["earthpower", "fireblast", "icebeam", "protect", "sludgebomb", "superpower"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		randomDoubleBattleMoves: ["followme", "helpinghand", "moonblast", "protect"],
		randomDoubleBattleLevel: 95,
		tier: "NFE",
	},
	clefable: {
		randomBattleMoves: ["calmmind", "fireblast", "moonblast", "softboiled", "stealthrock", "thunderwave"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["fireblast", "followme", "healpulse", "helpinghand", "moonblast", "protect", "thunderwave"],
		randomDoubleBattleLevel: 86,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	vulpix: {
		tier: "LC",
	},
	vulpixalola: {
		tier: "NFE",
		natDexTier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["fireblast", "nastyplot", "scorchingsands", "solarbeam", "willowisp"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["heatwave", "nastyplot", "protect", "scorchingsands", "solarbeam"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	ninetalesalola: {
		randomBattleMoves: ["auroraveil", "blizzard", "freezedry", "moonblast", "nastyplot"],
		randomBattleLevel: 79,
		randomDoubleBattleMoves: ["auroraveil", "blizzard", "encore", "freezedry", "moonblast"],
		randomDoubleBattleLevel: 81,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		randomBattleMoves: ["dazzlinggleam", "fireblast", "healbell", "lightscreen", "reflect", "stealthrock"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["dazzlinggleam", "healpulse", "helpinghand", "hypervoice", "thunderwave"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NFE",
	},
	crobat: {
		randomBattleMoves: ["bravebird", "defog", "roost", "superfang", "taunt", "toxic", "uturn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bravebird", "defog", "roost", "superfang", "tailwind", "taunt"],
		randomDoubleBattleLevel: 86,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["aromatherapy", "gigadrain", "sleeppowder", "sludgebomb", "strengthsap"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["aromatherapy", "energyball", "pollenpuff", "sleeppowder", "sludgebomb", "strengthsap"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bellossom: {
		randomBattleMoves: ["gigadrain", "moonblast", "quiverdance", "sleeppowder", "strengthsap"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["energyball", "moonblast", "quiverdance", "sleeppowder", "strengthsap"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	paras: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	parasect: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venonat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	venomoth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	diglett: {
		tier: "LC",
	},
	diglettalola: {
		tier: "LC",
	},
	dugtrio: {
		randomBattleMoves: ["earthquake", "memento", "stoneedge", "suckerpunch"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["highhorsepower", "memento", "protect", "rockslide", "suckerpunch"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dugtrioalola: {
		randomBattleMoves: ["earthquake", "ironhead", "stealthrock", "stoneedge", "suckerpunch"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["highhorsepower", "ironhead", "memento", "protect", "rockslide", "suckerpunch"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	meowth: {
		tier: "LC",
	},
	meowthalola: {
		tier: "LC",
	},
	meowthgalar: {
		tier: "LC",
	},
	meowthgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	persian: {
		randomBattleMoves: ["doubleedge", "fakeout", "knockoff", "playrough", "uturn"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["doubleedge", "fakeout", "hypnosis", "icywind", "knockoff", "taunt"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	persianalola: {
		randomBattleMoves: ["darkpulse", "hypnosis", "nastyplot", "thunderbolt"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["fakeout", "foulplay", "icywind", "partingshot", "snarl", "taunt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	perrserker: {
		randomBattleMoves: ["closecombat", "crunch", "fakeout", "ironhead", "uturn"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["closecombat", "fakeout", "ironhead", "lashout", "protect", "uturn"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["calmmind", "focusblast", "icebeam", "psyshock", "scald", "substitute"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["calmmind", "encore", "icebeam", "muddywater", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mankey: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	primeape: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	growlithe: {
		tier: "LC",
	},
	growlithehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	arcanine: {
		randomBattleMoves: ["closecombat", "extremespeed", "flareblitz", "morningsun", "toxic", "wildcharge", "willowisp"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "extremespeed", "flareblitz", "morningsun", "protect", "snarl", "willowisp"],
		randomDoubleBattleLevel: 84,
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	arcaninehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		randomBattleMoves: ["closecombat", "darkestlariat", "liquidation", "raindance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "coaching", "helpinghand", "liquidation", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	politoed: {
		randomBattleMoves: ["encore", "icebeam", "protect", "rest", "scald", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["haze", "helpinghand", "icywind", "protect", "scald"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NFE",
	},
	alakazam: {
		randomBattleMoves: ["counter", "focusblast", "nastyplot", "psychic", "shadowball"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["focusblast", "nastyplot", "protect", "psychic", "shadowball"],
		randomDoubleBattleLevel: 80,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	alakazammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NFE",
	},
	machamp: {
		randomBattleMoves: ["bulletpunch", "closecombat", "dynamicpunch", "facade", "knockoff", "stoneedge"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bulletpunch", "closecombat", "facade", "knockoff", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	machampgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	bellsprout: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	weepinbell: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	victreebel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["haze", "knockoff", "rapidspin", "scald", "sludgebomb", "toxicspikes"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["acidspray", "icywind", "knockoff", "muddywater", "rapidspin", "sludgebomb"],
		randomDoubleBattleLevel: 87,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	geodude: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	geodudealola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	graveler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	graveleralola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	golem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	golemalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ponyta: {
		tier: "LC",
	},
	ponytagalar: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["flareblitz", "highhorsepower", "morningsun", "swordsdance", "wildcharge", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flareblitz", "highhorsepower", "morningsun", "protect", "swordsdance", "wildcharge"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rapidashgalar: {
		randomBattleMoves: ["highhorsepower", "morningsun", "playrough", "swordsdance", "zenheadbutt"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["highhorsepower", "playrough", "protect", "swordsdance", "zenheadbutt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowpokegalar: {
		tier: "LC",
	},
	slowbro: {
		randomBattleMoves: ["futuresight", "icebeam", "scald", "slackoff", "teleport", "thunderwave"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["calmmind", "fireblast", "icebeam", "psychic", "scald", "slackoff", "trickroom"],
		randomDoubleBattleLevel: 84,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	slowbromega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	slowbrogalar: {
		randomBattleMoves: ["flamethrower", "psychic", "shellsidearm", "trick", "trickroom"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fireblast", "healpulse", "protect", "psychic", "shellsidearm", "trickroom"],
		randomDoubleBattleLevel: 85,
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	slowking: {
		randomBattleMoves: ["fireblast", "futuresight", "psyshock", "scald", "slackoff", "teleport", "toxic", "trick"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fireblast", "icebeam", "nastyplot", "psychic", "scald", "slackoff", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	slowkinggalar: {
		randomBattleMoves: ["fireblast", "futuresight", "psyshock", "slackoff", "sludgebomb", "trick"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["fireblast", "protect", "psychic", "sludgebomb", "trick", "trickroom"],
		randomDoubleBattleLevel: 86,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	magnezone: {
		randomBattleMoves: ["bodypress", "flashcannon", "mirrorcoat", "thunderbolt", "voltswitch"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bodypress", "electroweb", "flashcannon", "protect", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 88,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	farfetchd: {
		randomBattleMoves: ["bravebird", "closecombat", "knockoff", "leafblade", "swordsdance"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["bravebird", "closecombat", "leafblade", "protect", "quickattack", "swordsdance"],
		randomDoubleBattleLevel: 95,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	farfetchdgalar: {
		tier: "LC",
	},
	sirfetchd: {
		randomBattleMoves: ["bravebird", "closecombat", "firstimpression", "knockoff", "swordsdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bravebird", "closecombat", "firstimpression", "knockoff", "poisonjab", "protect", "swordsdance"],
		randomDoubleBattleLevel: 85,
		randomBattleNoDynamaxMoves: ["bravebird", "closecombat", "firstimpression", "knockoff", "poisonjab", "swordsdance"],
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	doduo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dodrio: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	seel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dewgong: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	grimer: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grimeralola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	muk: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mukalola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["explosion", "hydropump", "iciclespear", "rockblast", "shellsmash"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["hydropump", "iciclespear", "protect", "rockblast", "shellsmash"],
		randomDoubleBattleLevel: 84,
		randomBattleNoDynamaxMoves: ["hydropump", "iciclespear", "rockblast", "shellsmash"],
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gastly: {
		tier: "NFE",
		natDexTier: "LC",
	},
	haunter: {
		tier: "NFE",
	},
	gengar: {
		randomDoubleBattleMoves: ["focusblast", "nastyplot", "protect", "shadowball", "sludgebomb", "thunderbolt", "trick", "willowisp"],
		randomDoubleBattleLevel: 86,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	gengarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	gengargmax: {
		randomBattleMoves: ["focusblast", "nastyplot", "shadowball", "sludgewave", "trick"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["focusblast", "nastyplot", "protect", "shadowball", "sludgebomb", "thunderbolt", "willowisp"],
		randomDoubleBattleLevel: 86,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		randomBattleMoves: ["dragondance", "earthquake", "headsmash", "heavyslam", "stealthrock", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["headsmash", "heavyslam", "highhorsepower", "protect", "rockpolish"],
		randomDoubleBattleLevel: 88,
		randomBattleNoDynamaxMoves: ["curse", "earthquake", "headsmash", "heavyslam", "stealthrock", "toxic"],
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	steelixmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drowzee: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	hypno: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["agility", "liquidation", "rockslide", "superpower", "swordsdance", "xscissor"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["agility", "knockoff", "liquidation", "protect", "superpower", "xscissor"],
		randomDoubleBattleLevel: 86,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	kinglergmax: {
		randomDoubleBattleMoves: ["knockoff", "liquidation", "protect", "superpower", "xscissor"],
		randomDoubleBattleLevel: 86,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	voltorb: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	voltorbhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	electrode: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	electrodehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		randomBattleMoves: ["gigadrain", "leechseed", "psychic", "sleeppowder", "substitute"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["energyball", "protect", "psychic", "sleeppowder", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	exeggutoralola: {
		randomBattleMoves: ["dracometeor", "flamethrower", "gigadrain", "leafstorm", "trickroom"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["dragonpulse", "energyball", "flamethrower", "protect", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["doubleedge", "earthquake", "knockoff", "stealthrock", "stoneedge", "swordsdance"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["bonemerang", "knockoff", "protect", "stealthrock", "stoneedge"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	marowakalola: {
		randomBattleMoves: ["earthquake", "flamecharge", "flareblitz", "poltergeist", "stealthrock", "stoneedge"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bonemerang", "flamecharge", "flareblitz", "protect", "shadowbone"],
		randomDoubleBattleLevel: 83,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	marowakalolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		randomBattleMoves: ["closecombat", "curse", "highjumpkick", "knockoff", "poisonjab", "stoneedge"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "fakeout", "knockoff", "poisonjab", "protect", "rockslide"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hitmonchan: {
		randomBattleMoves: ["bulkup", "drainpunch", "icepunch", "machpunch", "rapidspin", "throatchop"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["coaching", "drainpunch", "feint", "firepunch", "icepunch", "machpunch"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hitmontop: {
		randomBattleMoves: ["closecombat", "earthquake", "rapidspin", "suckerpunch", "toxic", "tripleaxel"],
		randomBattleLevel: 85,
		randomDoubleBattleMoves: ["closecombat", "coaching", "fakeout", "helpinghand", "rapidspin", "suckerpunch", "tripleaxel"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		randomBattleMoves: ["bodyslam", "earthquake", "explosion", "healbell", "knockoff", "protect", "swordsdance", "wish"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["bodyslam", "explosion", "helpinghand", "icywind", "knockoff"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["fireblast", "painsplit", "sludgebomb", "toxicspikes", "willowisp"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fireblast", "painsplit", "sludgebomb", "toxicspikes", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	weezinggalar: {
		randomBattleMoves: ["defog", "fireblast", "painsplit", "sludgebomb", "strangesteam", "toxicspikes", "willowisp"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["clearsmog", "defog", "fireblast", "painsplit", "strangesteam", "toxicspikes", "willowisp"],
		randomDoubleBattleLevel: 89,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		randomBattleMoves: ["earthquake", "megahorn", "stealthrock", "stoneedge", "toxic"],
		randomBattleLevel: 87,
		tier: "NFE",
	},
	rhyperior: {
		randomBattleMoves: ["earthquake", "firepunch", "megahorn", "rockpolish", "stoneedge"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["highhorsepower", "icepunch", "megahorn", "protect", "rockslide", "stoneedge"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		randomBattleMoves: ["healbell", "seismictoss", "softboiled", "stealthrock", "toxic"],
		randomBattleLevel: 84,
		tier: "UU",
		doublesTier: "NFE",
		natDexTier: "OU",
	},
	blissey: {
		randomBattleMoves: ["seismictoss", "softboiled", "stealthrock", "teleport", "toxic"],
		randomBattleLevel: 83,
		randomDoubleBattleMoves: ["allyswitch", "healpulse", "helpinghand", "protect", "seismictoss", "softboiled", "thunderwave", "toxic"],
		randomDoubleBattleLevel: 88,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	tangela: {
		tier: "NFE",
		natDexTier: "LC",
	},
	tangrowth: {
		randomBattleMoves: ["earthquake", "gigadrain", "knockoff", "leechseed", "sleeppowder", "sludgebomb"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["focusblast", "knockoff", "powerwhip", "ragepowder", "sleeppowder"],
		randomDoubleBattleLevel: 85,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	kangaskhan: {
		randomBattleMoves: ["doubleedge", "earthquake", "fakeout", "hammerarm", "suckerpunch"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["doubleedge", "drainpunch", "fakeout", "protect", "rockslide", "suckerpunch"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	kangaskhanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		randomBattleMoves: ["dracometeor", "flipturn", "hurricane", "hydropump", "raindance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["dracometeor", "hurricane", "hydropump", "icebeam", "muddywater", "raindance"],
		randomDoubleBattleLevel: 82,
		randomBattleNoDynamaxMoves: ["dracometeor", "flipturn", "hydropump", "icebeam", "raindance"],
		tier: "PUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["drillrun", "knockoff", "megahorn", "swordsdance", "waterfall"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["drillrun", "knockoff", "megahorn", "protect", "scaleshot", "swordsdance", "waterfall"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["hydropump", "icebeam", "psyshock", "rapidspin", "recover", "scald", "thunderbolt"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["hydropump", "icebeam", "protect", "psyshock", "thunderbolt", "trick"],
		randomDoubleBattleLevel: 84,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		randomBattleMoves: ["dazzlinggleam", "focusblast", "healingwish", "nastyplot", "psychic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["dazzlinggleam", "fakeout", "icywind", "lightscreen", "psychic", "reflect"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mrmimegalar: {
		randomBattleMoves: ["focusblast", "freezedry", "nastyplot", "psychic", "rapidspin"],
		randomBattleLevel: 86,
		tier: "NFE",
	},
	mrrime: {
		randomBattleMoves: ["focusblast", "freezedry", "psychic", "rapidspin", "slackoff", "trick"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fakeout", "focusblast", "freezedry", "icywind", "protect", "psychic", "rapidspin"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scyther: {
		randomBattleMoves: ["brickbreak", "dualwingbeat", "knockoff", "roost", "swordsdance", "uturn"],
		randomBattleLevel: 81,
		randomDoubleBattleMoves: ["brickbreak", "bugbite", "dualwingbeat", "uturn"],
		randomDoubleBattleLevel: 84,
		tier: "PUBL",
		doublesTier: "NFE",
		natDexTier: "LC",
	},
	scizor: {
		randomBattleMoves: ["bulletpunch", "dualwingbeat", "knockoff", "roost", "superpower", "swordsdance", "uturn"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["bugbite", "bulletpunch", "dualwingbeat", "feint", "protect", "superpower", "swordsdance", "uturn"],
		randomDoubleBattleLevel: 80,
		randomBattleNoDynamaxMoves: ["bulletpunch", "knockoff", "roost", "superpower", "swordsdance", "uturn"],
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	scizormega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		randomBattleMoves: ["focusblast", "icebeam", "lovelykiss", "nastyplot", "psyshock", "trick"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["focusblast", "icebeam", "lovelykiss", "nastyplot", "psychic"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		randomBattleMoves: ["crosschop", "earthquake", "flamethrower", "icepunch", "voltswitch", "wildcharge"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["crosschop", "flamethrower", "icepunch", "stompingtantrum", "wildcharge"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	magby: {
		tier: "NFE",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		randomBattleMoves: ["earthquake", "fireblast", "focusblast", "psychic", "taunt", "thunderbolt"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fireblast", "focusblast", "heatwave", "protect", "thunderbolt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pinsir: {
		randomBattleMoves: ["closecombat", "earthquake", "knockoff", "stealthrock", "stoneedge", "xscissor"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "feint", "protect", "rockslide", "swordsdance", "xscissor"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pinsirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	tauros: {
		randomBattleMoves: ["bodyslam", "closecombat", "rockslide", "throatchop", "zenheadbutt"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bodyslam", "closecombat", "lashout", "protect", "rockslide"],
		randomDoubleBattleLevel: 84,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["bounce", "dragondance", "earthquake", "powerwhip", "waterfall"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["bounce", "dragondance", "icefang", "powerwhip", "protect", "waterfall"],
		randomDoubleBattleLevel: 81,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	gyaradosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	lapras: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	laprasgmax: {
		randomBattleMoves: ["freezedry", "icebeam", "protect", "sparklingaria", "thunderbolt", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["freezedry", "helpinghand", "hydropump", "icywind", "protect", "thunderbolt"],
		randomDoubleBattleLevel: 84,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["transform"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eevee: {
		tier: "LC",
	},
	eeveestarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	eeveegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	vaporeon: {
		randomBattleMoves: ["healbell", "icebeam", "protect", "scald", "toxic", "wish"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["helpinghand", "icywind", "protect", "scald", "toxic", "wish"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	jolteon: {
		randomBattleMoves: ["hypervoice", "shadowball", "thunderbolt", "voltswitch"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["faketears", "helpinghand", "shadowball", "thunderbolt", "thunderwave"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flareon: {
		randomBattleMoves: ["facade", "flamecharge", "flareblitz", "quickattack", "superpower"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["facade", "flamecharge", "flareblitz", "protect", "quickattack", "superpower"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	espeon: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "morningsun", "psychic", "shadowball"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "morningsun", "protect", "psychic", "shadowball"],
		randomDoubleBattleLevel: 84,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	umbreon: {
		randomBattleMoves: ["foulplay", "protect", "toxic", "wish"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["foulplay", "helpinghand", "moonlight", "protect", "snarl", "toxic"],
		randomDoubleBattleLevel: 88,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	leafeon: {
		randomBattleMoves: ["doubleedge", "knockoff", "leafblade", "swordsdance", "synthesis", "xscissor"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["doubleedge", "knockoff", "leafblade", "protect", "swordsdance"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaceon: {
		randomBattleMoves: ["freezedry", "protect", "toxic", "wish"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["blizzard", "freezedry", "helpinghand", "protect", "shadowball", "wish"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sylveon: {
		randomBattleMoves: ["calmmind", "hypervoice", "mysticalfire", "protect", "psyshock", "shadowball", "wish"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["calmmind", "hypervoice", "mysticalfire", "protect", "psyshock"],
		randomDoubleBattleLevel: 80,
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		randomBattleMoves: ["discharge", "icebeam", "recover", "toxic", "triattack"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["icebeam", "recover", "thunderbolt", "toxic", "triattack", "trickroom"],
		randomDoubleBattleLevel: 83,
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "NFE",
	},
	porygonz: {
		randomBattleMoves: ["darkpulse", "icebeam", "nastyplot", "thunderbolt", "triattack", "trick"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["darkpulse", "icebeam", "protect", "thunderbolt", "triattack", "trick"],
		randomDoubleBattleLevel: 84,
		randomBattleNoDynamaxMoves: ["icebeam", "nastyplot", "shadowball", "thunderbolt", "triattack", "trick"],
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["earthpower", "hydropump", "icebeam", "shellsmash", "spikes", "stealthrock"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["earthpower", "icebeam", "muddywater", "shellsmash"],
		randomDoubleBattleLevel: 86,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["aquajet", "knockoff", "liquidation", "rapidspin", "stoneedge", "swordsdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["aquajet", "protect", "stoneedge", "superpower", "swordsdance", "waterfall"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aerodactyl: {
		randomBattleMoves: ["aquatail", "dualwingbeat", "earthquake", "honeclaws", "stoneedge"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["aquatail", "dragondance", "dualwingbeat", "earthquake", "rockslide"],
		randomDoubleBattleLevel: 82,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aerodactylmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		randomBattleMoves: ["darkestlariat", "doubleedge", "earthquake", "facade", "heatcrash"],
		randomBattleLevel: 82,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snorlaxgmax: {
		randomBattleMoves: ["bodyslam", "curse", "darkestlariat", "earthquake", "rest"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bodyslam", "curse", "darkestlariat", "highhorsepower", "recycle"],
		randomDoubleBattleLevel: 84,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	articuno: {
		randomBattleMoves: ["defog", "freezedry", "healbell", "roost", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["freezedry", "healbell", "hurricane", "icebeam", "roost"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	articunogalar: {
		randomBattleMoves: ["airslash", "calmmind", "freezingglare", "recover"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["calmmind", "freezingglare", "hurricane", "recover", "tailwind"],
		randomDoubleBattleLevel: 81,
		randomBattleNoDynamaxMoves: ["calmmind", "freezingglare", "hurricane", "recover"],
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zapdos: {
		randomBattleMoves: ["defog", "discharge", "heatwave", "hurricane", "roost", "uturn"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["heatwave", "hurricane", "roost", "tailwind", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 79,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	zapdosgalar: {
		randomBattleMoves: ["bravebird", "bulkup", "closecombat", "throatchop", "uturn"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["bravebird", "bulkup", "closecombat", "throatchop", "thunderouskick", "uturn"],
		randomDoubleBattleLevel: 76,
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	moltres: {
		randomBattleMoves: ["airslash", "defog", "fireblast", "roost", "uturn"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["bravebird", "fireblast", "heatwave", "protect", "roost", "tailwind"],
		randomDoubleBattleLevel: 81,
		randomBattleNoDynamaxMoves: ["defog", "fireblast", "hurricane", "roost", "uturn"],
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	moltresgalar: {
		randomBattleMoves: ["fierywrath", "hurricane", "nastyplot", "rest"],
		randomBattleLevel: 75,
		randomDoubleBattleMoves: ["fierywrath", "hurricane", "nastyplot", "protect"],
		randomDoubleBattleLevel: 75,
		randomBattleNoDynamaxMoves: ["agility", "fierywrath", "hurricane", "nastyplot", "rest"],
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "UUBL",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		randomBattleMoves: ["dragondance", "dualwingbeat", "earthquake", "extremespeed", "outrage"],
		randomBattleLevel: 75,
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "dualwingbeat", "extremespeed", "firepunch"],
		randomDoubleBattleLevel: 82,
		randomBattleNoDynamaxMoves: ["dragondance", "dualwingbeat", "earthquake", "outrage", "roost"],
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	mewtwo: {
		randomBattleMoves: ["fireblast", "nastyplot", "psystrike", "recover", "shadowball"],
		randomBattleLevel: 72,
		randomDoubleBattleMoves: ["aurasphere", "icebeam", "nastyplot", "psystrike", "recover"],
		randomDoubleBattleLevel: 74,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	mewtwomegax: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mewtwomegay: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mew: {
		randomBattleMoves: ["bravebird", "closecombat", "dragondance", "flareblitz", "psychicfangs", "swordsdance"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["fakeout", "pollenpuff", "psychic", "stealthrock", "tailwind", "toxicspikes", "transform"],
		randomDoubleBattleLevel: 80,
		randomBattleNoDynamaxMoves: ["fireblast", "nastyplot", "psychic", "roost", "stealthrock", "toxicspikes"],
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UUBL",
	},
	chikorita: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bayleef: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	meganium: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cyndaquil: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	quilava: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	typhlosion: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	typhlosionhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	totodile: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	croconaw: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	feraligatr: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sentret: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	furret: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		randomBattleMoves: ["defog", "heatwave", "hurricane", "nastyplot", "roost"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["airslash", "heatwave", "hypervoice", "nastyplot", "roost", "tailwind"],
		randomDoubleBattleLevel: 84,
		randomBattleNoDynamaxMoves: ["defog", "heatwave", "hurricane", "nastyplot", "roost"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ledyba: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ledian: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spinarak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ariados: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		randomBattleMoves: ["healbell", "icebeam", "scald", "thunderbolt", "toxic", "voltswitch"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["healbell", "icebeam", "protect", "scald", "thunderbolt", "thunderwave"],
		randomDoubleBattleLevel: 90,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NFE",
	},
	togekiss: {
		randomBattleMoves: ["airslash", "aurasphere", "fireblast", "nastyplot", "roost", "thunderwave", "trick"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["airslash", "dazzlinggleam", "followme", "helpinghand", "protect", "tailwind"],
		randomDoubleBattleLevel: 80,
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		randomBattleMoves: ["heatwave", "psychic", "roost", "teleport", "thunderwave"],
		randomBattleLevel: 89,
		randomDoubleBattleMoves: ["airslash", "heatwave", "lightscreen", "psychic", "reflect", "roost", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mareep: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	flaaffy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	ampharos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	ampharosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		randomBattleMoves: ["aquajet", "knockoff", "liquidation", "playrough", "superpower"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["aquajet", "knockoff", "liquidation", "playrough", "protect"],
		randomDoubleBattleLevel: 87,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		randomBattleMoves: ["earthquake", "headsmash", "stealthrock", "suckerpunch", "woodhammer"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["bodypress", "firepunch", "headsmash", "protect", "suckerpunch", "woodhammer"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hoppip: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	skiploom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	jumpluff: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	aipom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ambipom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sunkern: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sunflora: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	yanma: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	yanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		randomBattleMoves: ["earthquake", "icebeam", "recover", "scald", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["highhorsepower", "protect", "recover", "scald", "yawn"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	murkrow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	honchkrow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	misdreavus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mismagius: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	unown: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		randomBattleMoves: ["charm", "counter", "encore", "mirrorcoat"],
		randomBattleLevel: 92,
		randomDoubleBattleMoves: ["charm", "counter", "encore", "mirrorcoat"],
		randomDoubleBattleLevel: 100,
		randomBattleNoDynamaxMoves: ["counter", "destinybond", "encore", "mirrorcoat"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	girafarig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pineco: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	forretress: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	dunsparce: {
		randomBattleMoves: ["bodyslam", "coil", "earthquake", "roost"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["glare", "headbutt", "protect", "rockslide"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gligar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gliscor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	snubbull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	granbull: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	qwilfish: {
		randomBattleMoves: ["destinybond", "spikes", "taunt", "thunderwave", "toxicspikes", "waterfall"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["liquidation", "poisonjab", "protect", "taunt", "thunderwave", "toxicspikes"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	qwilfishhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	shuckle: {
		randomBattleMoves: ["encore", "knockoff", "stealthrock", "stickyweb", "toxic"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["acupressure", "guardsplit", "helpinghand", "infestation", "knockoff", "stealthrock", "stickyweb", "toxic"],
		randomDoubleBattleLevel: 100,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	heracross: {
		randomBattleMoves: ["closecombat", "facade", "knockoff", "megahorn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "facade", "knockoff", "megahorn", "protect", "swordsdance"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	heracrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	sneasel: {
		tier: "NFE",
		natDexTier: "LC",
	},
	sneaselhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	weavile: {
		randomBattleMoves: ["iceshard", "knockoff", "lowkick", "swordsdance", "tripleaxel"],
		randomBattleLevel: 79,
		randomDoubleBattleMoves: ["fakeout", "iceshard", "knockoff", "lowkick", "tripleaxel"],
		randomDoubleBattleLevel: 84,
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	teddiursa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	ursaring: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	slugma: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	magcargo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NFE",
	},
	mamoswine: {
		randomBattleMoves: ["earthquake", "iceshard", "iciclecrash", "knockoff", "stealthrock", "superpower"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["highhorsepower", "iceshard", "iciclecrash", "protect", "rockslide"],
		randomDoubleBattleLevel: 83,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	corsola: {
		randomBattleMoves: ["powergem", "recover", "scald", "stealthrock", "toxic"],
		randomBattleLevel: 93,
		randomDoubleBattleMoves: ["icywind", "lifedew", "recover", "scald", "toxic"],
		randomDoubleBattleLevel: 95,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	corsolagalar: {
		randomBattleMoves: ["haze", "nightshade", "stealthrock", "strengthsap", "willowisp"],
		randomBattleLevel: 84,
		tier: "NFE",
		natDexTier: "LC",
	},
	cursola: {
		randomBattleMoves: ["earthpower", "hydropump", "icebeam", "shadowball", "stealthrock", "strengthsap"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["earthpower", "hydropump", "icebeam", "protect", "shadowball", "strengthsap"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		randomBattleMoves: ["energyball", "fireblast", "gunkshot", "hydropump", "icebeam", "protect"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fireblast", "gunkshot", "hydropump", "icebeam", "protect", "substitute"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	delibird: {
		randomBattleMoves: ["freezedry", "memento", "rapidspin", "spikes"],
		randomBattleLevel: 100,
		randomDoubleBattleMoves: ["bravebird", "defog", "fakeout", "helpinghand", "icepunch", "memento", "tailwind"],
		randomDoubleBattleLevel: 100,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		randomBattleMoves: ["defog", "hurricane", "icebeam", "roost", "scald", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["haze", "helpinghand", "hurricane", "roost", "scald", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	skarmory: {
		randomBattleMoves: ["bodypress", "bravebird", "roost", "spikes", "stealthrock", "whirlwind"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["bodypress", "bravebird", "irondefense", "roost"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	houndour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	houndoom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	houndoommega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	phanpy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	donphan: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	stantler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	smeargle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	miltank: {
		randomBattleMoves: ["bodyslam", "earthquake", "healbell", "milkdrink", "stealthrock", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bodypress", "bodyslam", "helpinghand", "icywind", "milkdrink", "protect", "rockslide"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	raikou: {
		randomBattleMoves: ["aurasphere", "calmmind", "scald", "substitute", "thunderbolt", "voltswitch"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["aurasphere", "calmmind", "protect", "scald", "snarl", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 82,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	entei: {
		randomBattleMoves: ["extremespeed", "flareblitz", "sacredfire", "stompingtantrum", "stoneedge"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["extremespeed", "protect", "sacredfire", "snarl", "stompingtantrum", "stoneedge"],
		randomDoubleBattleLevel: 79,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	suicune: {
		randomBattleMoves: ["airslash", "calmmind", "icebeam", "rest", "scald", "sleeptalk"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["calmmind", "icebeam", "scald", "snarl", "tailwind"],
		randomDoubleBattleLevel: 82,
		randomBattleNoDynamaxMoves: ["calmmind", "icebeam", "rest", "scald", "sleeptalk"],
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		randomBattleMoves: ["crunch", "dragondance", "earthquake", "firepunch", "stealthrock", "stoneedge"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["dragondance", "firepunch", "highhorsepower", "lashout", "protect", "rockslide", "stoneedge"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	tyranitarmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "(OU)",
	},
	lugia: {
		randomBattleMoves: ["airslash", "earthquake", "roost", "substitute", "toxic"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["aeroblast", "calmmind", "psyshock", "roost", "toxic"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	hooh: {
		randomBattleMoves: ["bravebird", "defog", "earthquake", "roost", "sacredfire", "toxic"],
		randomBattleLevel: 72,
		randomDoubleBattleMoves: ["bravebird", "earthpower", "protect", "roost", "sacredfire", "tailwind"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	celebi: {
		randomBattleMoves: ["earthpower", "gigadrain", "leafstorm", "nastyplot", "psychic", "recover", "stealthrock", "uturn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["earthpower", "energyball", "nastyplot", "protect", "psychic", "recover"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		randomBattleMoves: ["earthquake", "focusblast", "gigadrain", "leafstorm", "leechseed", "rockslide", "substitute"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["breakingswipe", "energyball", "focusblast", "leafstorm"],
		randomDoubleBattleLevel: 88,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sceptilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		randomBattleMoves: ["closecombat", "flareblitz", "knockoff", "stoneedge", "swordsdance"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["closecombat", "flareblitz", "knockoff", "protect", "swordsdance"],
		randomDoubleBattleLevel: 78,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	blazikenmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		randomBattleMoves: ["earthquake", "flipturn", "icebeam", "protect", "scald", "stealthrock", "toxic"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["highhorsepower", "icywind", "liquidation", "muddywater", "protect", "stealthrock", "wideguard"],
		randomDoubleBattleLevel: 86,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	swampertmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	poochyena: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	mightyena: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	zigzagoon: {
		tier: "NFE",
		natDexTier: "LC",
	},
	zigzagoongalar: {
		tier: "LC",
	},
	linoone: {
		randomBattleMoves: ["bellydrum", "extremespeed", "stompingtantrum", "throatchop"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bellydrum", "extremespeed", "protect", "throatchop"],
		randomDoubleBattleLevel: 90,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	linoonegalar: {
		tier: "NFE",
	},
	obstagoon: {
		randomBattleMoves: ["bulkup", "closecombat", "facade", "knockoff", "partingshot"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["closecombat", "facade", "knockoff", "obstruct", "partingshot", "taunt"],
		randomDoubleBattleLevel: 86,
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wurmple: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	silcoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	beautifly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cascoon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	dustox: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		randomBattleMoves: ["gigadrain", "hydropump", "icebeam", "raindance", "scald"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["energyball", "fakeout", "hydropump", "icebeam", "raindance"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		randomBattleMoves: ["darkpulse", "defog", "heatwave", "leafstorm", "nastyplot", "suckerpunch"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["defog", "fakeout", "knockoff", "leafblade", "suckerpunch", "tailwind"],
		randomDoubleBattleLevel: 88,
		randomBattleNoDynamaxMoves: ["defog", "knockoff", "leafblade", "lowkick", "rockslide", "suckerpunch", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	taillow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swellow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		randomBattleMoves: ["defog", "hurricane", "hydropump", "roost", "scald", "uturn"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["hurricane", "hydropump", "protect", "roost", "tailwind", "wideguard"],
		randomDoubleBattleLevel: 83,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		randomBattleMoves: ["calmmind", "moonblast", "mysticalfire", "psyshock", "substitute", "trick", "willowisp"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "moonblast", "mysticalfire", "protect", "psyshock", "trick"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gardevoirmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	gallade: {
		randomBattleMoves: ["closecombat", "knockoff", "shadowsneak", "swordsdance", "trick", "zenheadbutt"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "feint", "knockoff", "protect", "swordsdance", "tripleaxel", "zenheadbutt"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gallademega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	surskit: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	masquerain: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shroomish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	breloom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	slakoth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	vigoroth: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	slaking: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		randomBattleMoves: ["acrobatics", "leechlife", "swordsdance", "uturn"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["acrobatics", "defog", "leechlife", "protect", "swordsdance"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shedinja: {
		randomBattleMoves: ["poltergeist", "shadowsneak", "swordsdance", "willowisp", "xscissor"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["poltergeist", "protect", "shadowsneak", "swordsdance", "willowisp", "xscissor"],
		randomDoubleBattleLevel: 95,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		randomBattleMoves: ["boomburst", "fireblast", "focusblast", "surf"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["boomburst", "fireblast", "focusblast", "hypervoice", "icywind", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	makuhita: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	hariyama: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	nosepass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	probopass: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skitty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	delcatty: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	sableye: {
		randomBattleMoves: ["knockoff", "recover", "taunt", "toxic", "willowisp"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["disable", "encore", "fakeout", "foulplay", "knockoff", "quash", "recover", "willowisp"],
		randomDoubleBattleLevel: 88,
		randomBattleNoDynamaxMoves: ["encore", "knockoff", "recover", "taunt", "toxic", "willowisp"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sableyemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	mawile: {
		randomBattleMoves: ["ironhead", "playrough", "stealthrock", "suckerpunch", "swordsdance"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["firefang", "ironhead", "playrough", "protect", "suckerpunch", "swordsdance"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mawilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		randomBattleMoves: ["bodypress", "earthquake", "headsmash", "heavyslam", "rockpolish", "stealthrock"],
		randomBattleLevel: 85,
		randomDoubleBattleMoves: ["aquatail", "bodypress", "headsmash", "heavyslam", "highhorsepower", "rockpolish"],
		randomDoubleBattleLevel: 89,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	aggronmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	meditite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	medicham: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	medichammega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		randomBattleMoves: ["flamethrower", "overheat", "switcheroo", "thunderbolt", "voltswitch"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["overheat", "protect", "snarl", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	manectricmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	plusle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	minun: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	volbeat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	illumise: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NFE",
	},
	roserade: {
		randomBattleMoves: ["leafstorm", "sleeppowder", "sludgebomb", "spikes", "synthesis", "toxicspikes"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["energyball", "leafstorm", "protect", "sleeppowder", "sludgebomb"],
		randomDoubleBattleLevel: 86,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gulpin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swalot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		randomBattleMoves: ["closecombat", "crunch", "hydropump", "protect"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "crunch", "flipturn", "icebeam", "protect", "waterfall"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sharpedomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		randomBattleMoves: ["hydropump", "hypervoice", "icebeam", "waterspout"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["hydropump", "heavyslam", "icebeam", "waterspout"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	numel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	camerupt: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cameruptmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	torkoal: {
		randomBattleMoves: ["earthquake", "lavaplume", "rapidspin", "solarbeam", "stealthrock"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["bodypress", "earthpower", "fireblast", "heatwave", "protect", "solarbeam", "willowisp"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	spoink: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grumpig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spinda: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		randomBattleMoves: ["defog", "dragondance", "earthquake", "firepunch", "outrage", "uturn"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "earthquake", "firepunch", "protect", "rockslide", "tailwind"],
		randomDoubleBattleLevel: 86,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cacnea: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	cacturne: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		randomBattleMoves: ["defog", "dracometeor", "earthquake", "fireblast", "roost", "toxic"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["defog", "dracometeor", "fireblast", "roost", "tailwind", "toxic"],
		randomDoubleBattleLevel: 92,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	altariamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	zangoose: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	seviper: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lunatone: {
		randomBattleMoves: ["earthpower", "moonblast", "nastyplot", "powergem", "psychic", "stealthrock"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["earthpower", "icebeam", "meteorbeam", "protect", "psychic", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	solrock: {
		randomBattleMoves: ["earthquake", "explosion", "morningsun", "rockslide", "stealthrock", "willowisp"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["flareblitz", "helpinghand", "rockslide", "stoneedge", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		randomBattleMoves: ["dragondance", "earthquake", "liquidation", "stoneedge", "zenheadbutt"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["dragondance", "earthquake", "liquidation", "protect", "stoneedge"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		randomBattleMoves: ["aquajet", "closecombat", "crabhammer", "dragondance", "knockoff"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["aquajet", "closecombat", "crabhammer", "knockoff", "protect", "swordsdance"],
		randomDoubleBattleLevel: 86,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		randomBattleMoves: ["earthquake", "icebeam", "psychic", "rapidspin", "stealthrock", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["allyswitch", "earthpower", "icebeam", "psychic", "rapidspin"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		randomBattleMoves: ["powerwhip", "recover", "stealthrock", "stoneedge", "swordsdance", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["powerwhip", "protect", "recover", "stealthrock", "stoneedge", "stringshot"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		randomBattleMoves: ["earthquake", "knockoff", "liquidation", "rapidspin", "stealthrock", "stoneedge", "swordsdance"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["knockoff", "liquidation", "stoneedge", "superpower", "xscissor"],
		randomDoubleBattleLevel: 88,
		randomBattleNoDynamaxMoves: ["earthquake", "knockoff", "rapidspin", "stealthrock", "stoneedge", "swordsdance"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		randomBattleMoves: ["haze", "icebeam", "recover", "scald", "toxic"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["coil", "hypnosis", "muddywater", "recover"],
		randomDoubleBattleLevel: 80,
		tier: "RU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	castform: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	castformsunny: {
		isNonstandard: "Past",
	},
	castformrainy: {
		isNonstandard: "Past",
	},
	castformsnowy: {
		isNonstandard: "Past",
	},
	kecleon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shuppet: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	banette: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	banettemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		randomBattleMoves: ["earthquake", "icepunch", "painsplit", "poltergeist", "shadowsneak", "trick", "willowisp"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["earthquake", "haze", "icepunch", "poltergeist", "shadowsneak", "trickroom", "willowisp"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tropius: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chingling: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	chimecho: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	absol: {
		randomBattleMoves: ["closecombat", "knockoff", "playrough", "suckerpunch", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "knockoff", "protect", "suckerpunch", "swordsdance"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	absolmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		randomBattleMoves: ["disable", "earthquake", "freezedry", "protect", "substitute"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["disable", "earthquake", "freezedry", "protect", "substitute"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glaliemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	froslass: {
		randomBattleMoves: ["destinybond", "poltergeist", "spikes", "taunt", "tripleaxel", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["destinybond", "icebeam", "icywind", "protect", "shadowball", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		randomBattleMoves: ["icebeam", "protect", "surf", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["brine", "icebeam", "icywind", "superfang"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	clamperl: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	huntail: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gorebyss: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	relicanth: {
		randomBattleMoves: ["bodypress", "earthquake", "headsmash", "liquidation", "stealthrock", "yawn"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["bodypress", "headsmash", "liquidation", "stealthrock", "yawn"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	luvdisc: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		randomBattleMoves: ["dragondance", "dualwingbeat", "earthquake", "outrage", "roost"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["dragonclaw", "fireblast", "hurricane", "protect", "tailwind"],
		randomDoubleBattleLevel: 79,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	salamencemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NFE",
	},
	metagross: {
		randomBattleMoves: ["agility", "bulletpunch", "earthquake", "explosion", "meteormash", "stealthrock", "thunderpunch"],
		randomBattleLevel: 79,
		randomDoubleBattleMoves: ["agility", "bulletpunch", "icepunch", "meteormash", "stompingtantrum", "trick", "zenheadbutt"],
		randomDoubleBattleLevel: 82,
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	metagrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	regirock: {
		randomBattleMoves: ["bodypress", "curse", "earthquake", "explosion", "rest", "rockslide", "stoneedge"],
		randomBattleLevel: 85,
		randomDoubleBattleMoves: ["bodypress", "curse", "rest", "rockslide"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	regice: {
		randomBattleMoves: ["focusblast", "icebeam", "rest", "rockpolish", "sleeptalk", "thunderbolt"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["focusblast", "icebeam", "icywind", "rockpolish", "thunderbolt"],
		randomDoubleBattleLevel: 87,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	registeel: {
		randomBattleMoves: ["bodypress", "curse", "ironhead", "protect", "rest", "sleeptalk", "stealthrock", "toxic"],
		randomBattleLevel: 83,
		randomDoubleBattleMoves: ["bodypress", "curse", "ironhead", "rest", "toxic"],
		randomDoubleBattleLevel: 86,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	latias: {
		randomBattleMoves: ["calmmind", "dracometeor", "healingwish", "mysticalfire", "psychic", "roost"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["calmmind", "dracometeor", "healpulse", "mysticalfire", "psyshock", "roost", "tailwind"],
		randomDoubleBattleLevel: 82,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	latiasmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	latios: {
		randomBattleMoves: ["calmmind", "dracometeor", "mysticalfire", "psyshock", "roost", "trick"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["dracometeor", "mysticalfire", "psychic", "psyshock", "roost", "tailwind", "trick"],
		randomDoubleBattleLevel: 80,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	latiosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	kyogre: {
		randomBattleMoves: ["calmmind", "icebeam", "originpulse", "thunder", "waterspout"],
		randomBattleLevel: 72,
		randomDoubleBattleMoves: ["icebeam", "originpulse", "thunder", "waterspout"],
		randomDoubleBattleLevel: 69,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	kyogreprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	groudon: {
		randomBattleMoves: ["heatcrash", "heavyslam", "precipiceblades", "stealthrock", "stoneedge", "swordsdance", "thunderwave"],
		randomBattleLevel: 73,
		randomDoubleBattleMoves: ["heatcrash", "precipiceblades", "rockpolish", "stoneedge", "swordsdance"],
		randomDoubleBattleLevel: 72,
		randomBattleNoDynamaxMoves: ["heatcrash", "precipiceblades", "stealthrock", "stoneedge", "swordsdance", "thunderwave"],
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	groudonprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	rayquaza: {
		randomBattleMoves: ["dracometeor", "dragonascent", "dragondance", "earthquake", "extremespeed", "swordsdance", "vcreate"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["dracometeor", "dragonascent", "dragonclaw", "dragondance", "earthpower", "extremespeed", "vcreate"],
		randomDoubleBattleLevel: 74,
		randomBattleNoDynamaxMoves: ["dracometeor", "dragonascent", "dragondance", "earthquake", "extremespeed", "vcreate"],
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	rayquazamega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	jirachi: {
		randomBattleMoves: ["bodyslam", "firepunch", "ironhead", "stealthrock", "toxic", "trick", "uturn"],
		randomBattleLevel: 79,
		randomDoubleBattleMoves: ["firepunch", "followme", "ironhead", "lifedew", "protect", "thunderwave"],
		randomDoubleBattleLevel: 77,
		tier: "UU",
		doublesTier: "DUber",
		natDexTier: "UUBL",
	},
	deoxys: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	deoxysattack: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	deoxysdefense: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	deoxysspeed: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	turtwig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	grotle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	torterra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	chimchar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	monferno: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	infernape: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UU",
	},
	piplup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	prinplup: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	empoleon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	starly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	staravia: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	staraptor: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RUBL",
	},
	bidoof: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bibarel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	kricketot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	kricketune: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		randomBattleMoves: ["agility", "crunch", "facade", "superpower", "voltswitch", "wildcharge"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["playrough", "protect", "superpower", "voltswitch", "wildcharge"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cranidos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	rampardos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shieldon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	bastiodon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	burmy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	wormadam: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamsandy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	wormadamtrash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mothim: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		randomBattleMoves: ["airslash", "defog", "roost", "toxic", "uturn"],
		randomBattleLevel: 96,
		randomDoubleBattleMoves: ["airslash", "roost", "tailwind", "toxicspikes"],
		randomDoubleBattleLevel: 98,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pachirisu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	buizel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	floatzel: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cherubi: {
		tier: "NFE",
		natDexTier: "LC",
	},
	cherrim: {
		randomBattleMoves: ["dazzlinggleam", "energyball", "healingwish", "petaldance", "pollenpuff"],
		randomBattleLevel: 93,
		randomDoubleBattleMoves: ["energyball", "healingwish", "helpinghand", "pollenpuff"],
		randomDoubleBattleLevel: 92,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cherrimsunshine: {
		randomDoubleBattleMoves: ["playrough", "solarblade", "sunnyday", "weatherball"],
		randomDoubleBattleLevel: 92,
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		randomBattleMoves: ["clearsmog", "earthquake", "icebeam", "recover", "scald", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["clearsmog", "earthpower", "icywind", "recover", "scald", "yawn"],
		randomDoubleBattleLevel: 80,
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	drifloon: {
		tier: "NFE",
		natDexTier: "LC",
	},
	drifblim: {
		randomBattleMoves: ["calmmind", "shadowball", "strengthsap", "thunderbolt"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["calmmind", "icywind", "shadowball", "strengthsap"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		randomBattleMoves: ["closecombat", "facade", "healingwish", "switcheroo"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["closecombat", "fakeout", "switcheroo", "uturn"],
		randomDoubleBattleLevel: 92,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lopunnymega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	glameow: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	purugly: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		randomBattleMoves: ["crunch", "defog", "fireblast", "poisonjab", "suckerpunch", "taunt", "toxic"],
		randomBattleLevel: 85,
		randomDoubleBattleMoves: ["crunch", "defog", "fireblast", "poisonjab", "suckerpunch", "taunt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		randomBattleMoves: ["earthquake", "ironhead", "protect", "stealthrock", "toxic"],
		randomBattleLevel: 83,
		randomDoubleBattleMoves: ["allyswitch", "bodypress", "ironhead", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chatot: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	spiritomb: {
		randomBattleMoves: ["foulplay", "poltergeist", "shadowsneak", "suckerpunch", "trick"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["foulplay", "poltergeist", "protect", "snarl", "suckerpunch", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NFE",
	},
	garchomp: {
		randomBattleMoves: ["earthquake", "fireblast", "firefang", "outrage", "stealthrock", "stoneedge", "swordsdance"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["dragonclaw", "earthquake", "fireblast", "protect", "rockslide", "swordsdance"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	garchompmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "(OU)",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		randomBattleMoves: ["closecombat", "extremespeed", "meteormash", "stoneedge", "swordsdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "extremespeed", "icepunch", "meteormash", "protect", "swordsdance"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lucariomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		randomBattleMoves: ["earthquake", "slackoff", "stealthrock", "stoneedge", "toxic", "whirlwind"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["highhorsepower", "slackoff", "stealthrock", "whirlwind", "yawn"],
		randomDoubleBattleLevel: 88,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		randomBattleMoves: ["aquatail", "earthquake", "knockoff", "poisonjab", "swordsdance", "taunt", "toxicspikes"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["knockoff", "poisonjab", "protect", "swordsdance", "taunt"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		randomBattleMoves: ["drainpunch", "gunkshot", "icepunch", "knockoff", "substitute", "suckerpunch", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["drainpunch", "fakeout", "gunkshot", "protect", "suckerpunch", "swordsdance", "taunt"],
		randomDoubleBattleLevel: 86,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carnivine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	finneon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	lumineon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		randomBattleMoves: ["auroraveil", "blizzard", "earthquake", "iceshard", "woodhammer"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["auroraveil", "blizzard", "iceshard", "protect", "woodhammer"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	abomasnowmega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rotom: {
		randomBattleMoves: ["nastyplot", "shadowball", "thunderbolt", "voltswitch", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["electroweb", "protect", "shadowball", "thunderbolt", "voltswitch", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomheat: {
		randomBattleMoves: ["defog", "nastyplot", "overheat", "thunderbolt", "voltswitch", "willowisp"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["electroweb", "overheat", "protect", "thunderbolt", "voltswitch", "willowisp"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	rotomwash: {
		randomBattleMoves: ["hydropump", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["hydropump", "protect", "thunderbolt", "thunderwave", "voltswitch", "willowisp"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	rotomfrost: {
		randomBattleMoves: ["blizzard", "nastyplot", "thunderbolt", "voltswitch", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["blizzard", "nastyplot", "protect", "thunderbolt", "willowisp"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotomfan: {
		randomBattleMoves: ["airslash", "nastyplot", "thunderbolt", "voltswitch", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["airslash", "nastyplot", "protect", "thunderbolt"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rotommow: {
		randomBattleMoves: ["leafstorm", "nastyplot", "thunderbolt", "trick", "voltswitch", "willowisp"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["electroweb", "leafstorm", "protect", "thunderbolt", "voltswitch", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	uxie: {
		randomBattleMoves: ["healbell", "knockoff", "psychic", "stealthrock", "uturn", "yawn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["helpinghand", "knockoff", "psychic", "stealthrock", "thunderwave", "u-turn", "yawn"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mesprit: {
		randomBattleMoves: ["energyball", "healingwish", "icebeam", "nastyplot", "psychic", "stealthrock", "thunderwave", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["dazzlinggleam", "knockoff", "nastyplot", "psychic", "thunderbolt", "thunderwave"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	azelf: {
		randomBattleMoves: ["dazzlinggleam", "fireblast", "nastyplot", "psychic", "psyshock", "stealthrock", "taunt", "uturn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["energyball", "fireblast", "nastyplot", "psychic", "shadowball", "uturn"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dialga: {
		randomBattleMoves: ["dracometeor", "fireblast", "flashcannon", "stealthrock", "thunderbolt", "toxic"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["dracometeor", "earthpower", "fireblast", "flashcannon", "protect", "thunderbolt", "thunderwave"],
		randomDoubleBattleLevel: 74,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	dialgaorigin: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	palkia: {
		randomBattleMoves: ["dracometeor", "fireblast", "hydropump", "spacialrend", "thunderwave"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["fireblast", "hydropump", "protect", "spacialrend", "thunderbolt", "thunderwave"],
		randomDoubleBattleLevel: 74,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	palkiaorigin: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	heatran: {
		randomBattleMoves: ["earthpower", "flashcannon", "lavaplume", "protect", "stealthrock", "taunt", "toxic"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["earthpower", "eruption", "flashcannon", "heatwave", "protect"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	regigigas: {
		randomBattleMoves: ["bodyslam", "protect", "substitute", "toxic"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bodyslam", "knockoff", "protect", "thunderwave"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	giratina: {
		randomBattleMoves: ["hex", "rest", "sleeptalk", "toxic", "willowisp"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["calmmind", "dragonpulse", "rest", "shadowball", "willowisp"],
		randomDoubleBattleLevel: 74,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	giratinaorigin: {
		randomBattleMoves: ["dualwingbeat", "honeclaws", "outrage", "poltergeist", "shadowsneak"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["dracometeor", "protect", "shadowball", "shadowsneak", "tailwind", "willowisp"],
		randomDoubleBattleLevel: 74,
		randomBattleNoDynamaxMoves: ["defog", "dracometeor", "earthquake", "poltergeist", "shadowsneak", "willowisp"],
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	cresselia: {
		randomBattleMoves: ["calmmind", "moonblast", "moonlight", "psyshock", "thunderwave", "toxic"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["helpinghand", "icywind", "moonblast", "moonlight", "psychic", "thunderwave"],
		randomDoubleBattleLevel: 83,
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	phione: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	manaphy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	darkrai: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	shaymin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	shayminsky: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	arceus: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	arceusbug: {
		isNonstandard: "Past",
	},
	arceusdark: {
		isNonstandard: "Past",
	},
	arceusdragon: {
		isNonstandard: "Past",
	},
	arceuselectric: {
		isNonstandard: "Past",
	},
	arceusfairy: {
		isNonstandard: "Past",
	},
	arceusfighting: {
		isNonstandard: "Past",
	},
	arceusfire: {
		isNonstandard: "Past",
	},
	arceusflying: {
		isNonstandard: "Past",
	},
	arceusghost: {
		isNonstandard: "Past",
	},
	arceusgrass: {
		isNonstandard: "Past",
	},
	arceusground: {
		isNonstandard: "Past",
	},
	arceusice: {
		isNonstandard: "Past",
	},
	arceuspoison: {
		isNonstandard: "Past",
	},
	arceuspsychic: {
		isNonstandard: "Past",
	},
	arceusrock: {
		isNonstandard: "Past",
	},
	arceussteel: {
		isNonstandard: "Past",
	},
	arceuswater: {
		isNonstandard: "Past",
	},
	victini: {
		randomBattleMoves: ["blueflare", "boltstrike", "energyball", "glaciate", "uturn", "vcreate", "zenheadbutt"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["boltstrike", "glaciate", "protect", "uturn", "vcreate", "zenheadbutt"],
		randomDoubleBattleLevel: 81,
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	snivy: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	servine: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	serperior: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tepig: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pignite: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	emboar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oshawott: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	dewott: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	samurott: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	samurotthisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	patrat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	watchog: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		randomBattleMoves: ["crunch", "facade", "playrough", "superpower", "wildcharge"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["facade", "helpinghand", "superpower", "thunderwave"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		randomBattleMoves: ["copycat", "encore", "knockoff", "playrough", "thunderwave", "uturn"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["copycat", "encore", "fakeout", "foulplay", "snarl", "taunt", "thunderwave"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pansage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisage: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pansear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simisear: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	panpour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	simipour: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		randomBattleMoves: ["calmmind", "moonblast", "moonlight", "psychic", "thunderwave"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["helpinghand", "hypnosis", "moonblast", "psychic", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		randomBattleMoves: ["bravebird", "defog", "nightslash", "roost", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bravebird", "nightslash", "quickattack", "tailwind", "uturn"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	blitzle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	zebstrika: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		randomBattleMoves: ["earthquake", "explosion", "stealthrock", "stoneedge", "superpower"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bodypress", "explosion", "protect", "rockslide", "stealthrock", "stompingtantrum", "stoneedge", "wideguard"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	woobat: {
		tier: "NFE",
		natDexTier: "LC",
	},
	swoobat: {
		randomBattleMoves: ["airslash", "calmmind", "heatwave", "roost", "storedpower"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["airslash", "calmmind", "heatwave", "psychic"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		randomBattleMoves: ["earthquake", "ironhead", "rapidspin", "rockslide", "swordsdance"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["highhorsepower", "ironhead", "protect", "rapidspin", "rockslide", "swordsdance"],
		randomDoubleBattleLevel: 80,
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	audino: {
		randomBattleMoves: ["healbell", "knockoff", "protect", "toxic", "wish"],
		randomBattleLevel: 91,
		randomDoubleBattleMoves: ["bodyslam", "healpulse", "helpinghand", "knockoff", "protect", "thunderwave"],
		randomDoubleBattleLevel: 90,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	audinomega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		randomBattleMoves: ["bulkup", "defog", "drainpunch", "knockoff", "machpunch"],
		randomBattleLevel: 83,
		tier: "NFE",
	},
	conkeldurr: {
		randomBattleMoves: ["closecombat", "drainpunch", "facade", "knockoff", "machpunch"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["closecombat", "drainpunch", "icepunch", "knockoff", "machpunch", "protect"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		randomBattleMoves: ["earthquake", "liquidation", "raindance", "sludgebomb", "stealthrock"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["earthpower", "knockoff", "muddywater", "powerwhip", "protect", "raindance"],
		randomDoubleBattleLevel: 86,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	throh: {
		randomBattleMoves: ["bulkup", "circlethrow", "icepunch", "knockoff", "rest", "sleeptalk", "stormthrow"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["facade", "knockoff", "protect", "stoneedge", "stormthrow", "wideguard"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sawk: {
		randomBattleMoves: ["bulkup", "closecombat", "knockoff", "poisonjab", "stoneedge"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["closecombat", "helpinghand", "knockoff", "poisonjab", "protect", "rockslide"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sewaddle: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swadloon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	leavanny: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		randomBattleMoves: ["earthquake", "megahorn", "poisonjab", "protect", "spikes", "swordsdance", "toxicspikes"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["megahorn", "poisonjab", "protect", "rockslide", "superpower", "swordsdance"],
		randomDoubleBattleLevel: 84,
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		randomBattleMoves: ["defog", "energyball", "leechseed", "moonblast", "stunspore", "taunt", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["encore", "energyball", "helpinghand", "moonblast", "tailwind", "taunt"],
		randomDoubleBattleLevel: 82,
		randomBattleNoDynamaxMoves: ["defog", "encore", "energyball", "leechseed", "moonblast", "stunspore", "taunt", "uturn"],
		tier: "PU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		randomBattleMoves: ["gigadrain", "petaldance", "pollenpuff", "quiverdance", "sleeppowder"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["energyball", "pollenpuff", "quiverdance", "sleeppowder"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lilliganthisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	basculin: {
		randomBattleMoves: ["aquajet", "crunch", "flipturn", "liquidation", "psychicfangs", "superpower"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["flipturn", "liquidation", "muddywater", "protect", "superpower"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	basculinbluestriped: {
		randomBattleMoves: ["aquajet", "crunch", "flipturn", "liquidation", "psychicfangs", "superpower"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["flipturn", "liquidation", "muddywater", "protect", "superpower"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	basculinwhitestriped: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		randomBattleMoves: ["closecombat", "earthquake", "knockoff", "stealthrock", "stoneedge"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["closecombat", "highhorsepower", "knockoff", "protect", "rockslide", "taunt"],
		randomDoubleBattleLevel: 81,
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "UU",
	},
	darumaka: {
		tier: "LC",
	},
	darumakagalar: {
		tier: "LC",
	},
	darmanitan: {
		randomBattleMoves: ["earthquake", "flareblitz", "rockslide", "superpower", "uturn"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["earthquake", "flareblitz", "protect", "rockslide", "superpower", "uturn"],
		randomDoubleBattleLevel: 82,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	darmanitanzen: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	darmanitangalar: {
		randomBattleMoves: ["earthquake", "flareblitz", "iciclecrash", "superpower", "uturn"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["flareblitz", "iciclecrash", "rockslide", "superpower", "uturn"],
		randomDoubleBattleLevel: 80,
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	darmanitangalarzen: {
		randomBattleMoves: ["bellydrum", "earthquake", "firepunch", "iciclecrash", "substitute"],
		randomBattleLevel: 78,
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	maractus: {
		randomBattleMoves: ["energyball", "knockoff", "leechseed", "spikes", "spikyshield", "toxic"],
		randomBattleLevel: 95,
		randomDoubleBattleMoves: ["acupressure", "helpinghand", "leafstorm", "leechseed", "spikyshield"],
		randomDoubleBattleLevel: 96, // buffed twice in the last 6 months as of Nov 2021
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dwebble: {
		tier: "LC",
	},
	crustle: {
		randomBattleMoves: ["earthquake", "shellsmash", "spikes", "stealthrock", "stoneedge", "xscissor"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["knockoff", "protect", "rockslide", "shellsmash", "xscissor"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scraggy: {
		tier: "NFE",
		natDexTier: "LC",
	},
	scrafty: {
		randomBattleMoves: ["closecombat", "dragondance", "icepunch", "knockoff", "poisonjab"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "coaching", "drainpunch", "fakeout", "icepunch", "knockoff"],
		randomDoubleBattleLevel: 84,
		tier: "PUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	sigilyph: {
		randomBattleMoves: ["airslash", "defog", "energyball", "heatwave", "psychic"],
		randomBattleLevel: 83,
		randomDoubleBattleMoves: ["airslash", "heatwave", "protect", "psychic", "tailwind"],
		randomDoubleBattleLevel: 86,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	yamask: {
		tier: "LC",
	},
	yamaskgalar: {
		tier: "LC",
	},
	cofagrigus: {
		randomBattleMoves: ["bodypress", "memento", "shadowball", "toxicspikes", "willowisp"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["bodypress", "irondefense", "painsplit", "shadowball", "trickroom", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	runerigus: {
		randomBattleMoves: ["earthquake", "haze", "poltergeist", "stealthrock", "toxicspikes", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["earthquake", "poltergeist", "protect", "toxicspikes", "trickroom", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		randomBattleMoves: ["aquajet", "hydropump", "shellsmash", "stoneedge", "superpower"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["aquajet", "liquidation", "shellsmash", "stoneedge", "superpower"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		randomBattleMoves: ["dualwingbeat", "earthquake", "roost", "stoneedge", "uturn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["aquatail", "dualwingbeat", "earthquake", "protect", "rockslide", "uturn"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	garbodorgmax: {
		randomBattleMoves: ["explosion", "gunkshot", "painsplit", "spikes", "stompingtantrum", "toxicspikes"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["drainpunch", "explosion", "gunkshot", "protect", "toxicspikes"],
		randomDoubleBattleLevel: 90,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	zorua: {
		tier: "LC",
	},
	zoruahisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	zoroark: {
		randomBattleMoves: ["darkpulse", "flamethrower", "nastyplot", "sludgebomb", "trick"],
		randomDoubleBattleMoves: ["darkpulse", "flamethrower", "focusblast", "nastyplot", "protect", "sludgebomb"],
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zoroarkhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		randomBattleMoves: ["bulletseed", "knockoff", "rockblast", "tailslap", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bulletseed", "knockoff", "protect", "rockblast", "tailslap", "tripleaxel", "uturn"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gothita: {
		tier: "NFE",
		natDexTier: "LC",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		randomBattleMoves: ["nastyplot", "psychic", "shadowball", "thunderbolt", "trick"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fakeout", "healpulse", "helpinghand", "hypnosis", "protect", "psychic", "trickroom"],
		randomDoubleBattleLevel: 83,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		randomBattleMoves: ["calmmind", "focusblast", "psychic", "recover", "shadowball", "trickroom"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["focusblast", "protect", "psychic", "shadowball", "trickroom"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	ducklett: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	swanna: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		randomBattleMoves: ["auroraveil", "blizzard", "explosion", "flashcannon", "freezedry"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["auroraveil", "blizzard", "explosion", "freezedry", "protect"],
		randomDoubleBattleLevel: 82,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	deerling: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	sawsbuck: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	emolga: {
		randomBattleMoves: ["airslash", "defog", "energyball", "roost", "thunderbolt", "toxic", "uturn"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["acrobatics", "helpinghand", "nuzzle", "tailwind", "taunt", "voltswitch"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		randomBattleMoves: ["closecombat", "drillrun", "ironhead", "knockoff", "megahorn", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "drillrun", "ironhead", "knockoff", "megahorn", "protect", "swordsdance"],
		randomDoubleBattleLevel: 86,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		randomBattleMoves: ["gigadrain", "sludgebomb", "spore", "synthesis", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["clearsmog", "pollenpuff", "protect", "ragepowder", "spore"],
		randomDoubleBattleLevel: 81,
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		randomBattleMoves: ["icebeam", "recover", "scald", "shadowball", "toxic", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["scald", "shadowball", "strengthsap", "trickroom", "willowisp"],
		randomDoubleBattleLevel: 84,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	alomomola: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		randomBattleMoves: ["bugbuzz", "gigadrain", "stickyweb", "thunder", "voltswitch"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bugbuzz", "electroweb", "energyball", "protect", "stickyweb", "thunder"],
		randomDoubleBattleLevel: 85,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ferroseed: {
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "LC",
	},
	ferrothorn: {
		randomBattleMoves: ["gyroball", "knockoff", "leechseed", "powerwhip", "protect", "spikes", "stealthrock"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["bodypress", "gyroball", "leechseed", "powerwhip", "protect", "toxic"],
		randomDoubleBattleLevel: 83,
		tier: "OU",
		doublesTier: "DUU",
		natDexTier: "OU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "NFE",
	},
	klinklang: {
		randomBattleMoves: ["geargrind", "shiftgear", "substitute", "wildcharge"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["geargrind", "protect", "shiftgear", "wildcharge"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tynamo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	eelektrik: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	eelektross: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		randomBattleMoves: ["psychic", "shadowball", "thunderbolt", "trick", "trickroom"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["protect", "psychic", "shadowball", "thunderbolt", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		randomBattleMoves: ["calmmind", "energyball", "fireblast", "shadowball", "substitute", "trick"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["calmmind", "energyball", "heatwave", "overheat", "protect", "shadowball", "trick"],
		randomDoubleBattleLevel: 80,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "NFE",
	},
	haxorus: {
		randomBattleMoves: ["closecombat", "dragondance", "earthquake", "outrage", "poisonjab"],
		randomBattleLevel: 77,
		randomDoubleBattleMoves: ["closecombat", "dragonclaw", "dragondance", "poisonjab", "protect"],
		randomDoubleBattleLevel: 84,
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		randomBattleMoves: ["aquajet", "iciclecrash", "stoneedge", "superpower", "swordsdance"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["aquajet", "iciclecrash", "protect", "superpower", "swordsdance"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cryogonal: {
		randomBattleMoves: ["freezedry", "haze", "rapidspin", "recover", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["freezedry", "haze", "icebeam", "icywind", "rapidspin", "recover", "toxic"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		randomBattleMoves: ["bugbuzz", "energyball", "focusblast", "sludgebomb", "spikes", "toxic", "yawn"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["acidspray", "bugbuzz", "encore", "energyball", "focusblast"],
		randomDoubleBattleLevel: 88,
		randomBattleNoDynamaxMoves: ["bugbuzz", "encore", "energyball", "focusblast", "spikes", "toxic"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stunfisk: {
		randomBattleMoves: ["discharge", "earthpower", "foulplay", "sludgebomb", "stealthrock"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["earthpower", "electroweb", "foulplay", "stealthrock", "thunderbolt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stunfiskgalar: {
		randomBattleMoves: ["earthquake", "painsplit", "stealthrock", "stoneedge", "thunderwave"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["earthquake", "stealthrock", "stoneedge", "thunderwave", "yawn"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		randomBattleMoves: ["closecombat", "fakeout", "knockoff", "poisonjab", "stoneedge", "swordsdance", "uturn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "fakeout", "knockoff", "poisonjab", "protect", "uturn"],
		randomDoubleBattleLevel: 84,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	druddigon: {
		randomBattleMoves: ["earthquake", "glare", "gunkshot", "outrage", "stealthrock", "suckerpunch", "superpower"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["dragonclaw", "firepunch", "glare", "gunkshot", "protect", "suckerpunch"],
		randomDoubleBattleLevel: 87,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		randomBattleMoves: ["dynamicpunch", "earthquake", "poltergeist", "rockpolish", "stoneedge"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["dynamicpunch", "highhorsepower", "icepunch", "poltergeist", "protect"],
		randomDoubleBattleLevel: 86,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pawniard: {
		tier: "LC",
	},
	bisharp: {
		randomBattleMoves: ["ironhead", "knockoff", "stealthrock", "suckerpunch", "swordsdance"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["ironhead", "knockoff", "protect", "suckerpunch", "swordsdance"],
		randomDoubleBattleLevel: 84,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	bouffalant: {
		randomBattleMoves: ["closecombat", "earthquake", "headcharge", "megahorn", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "headcharge", "lashout", "protect", "wildcharge"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rufflet: {
		tier: "NFE",
		natDexTier: "LC",
	},
	braviary: {
		randomBattleMoves: ["bravebird", "bulkup", "closecombat", "roost"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bravebird", "bulkup", "closecombat", "roost", "tailwind"],
		randomDoubleBattleLevel: 82,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	braviaryhisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	vullaby: {
		tier: "NFE",
		natDexTier: "LC",
	},
	mandibuzz: {
		randomBattleMoves: ["bravebird", "defog", "foulplay", "roost", "toxic"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["foulplay", "roost", "snarl", "tailwind", "taunt"],
		randomDoubleBattleLevel: 88,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	heatmor: {
		randomBattleMoves: ["firelash", "gigadrain", "knockoff", "substitute", "suckerpunch", "superpower"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["firelash", "gigadrain", "incinerate", "protect", "suckerpunch", "superpower"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	durant: {
		randomBattleMoves: ["firstimpression", "honeclaws", "ironhead", "rockslide", "superpower"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["firstimpression", "ironhead", "protect", "stompingtantrum", "superpower", "xscissor"],
		randomDoubleBattleLevel: 82,
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		randomBattleMoves: ["darkpulse", "dracometeor", "fireblast", "flashcannon", "nastyplot", "roost", "uturn"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["darkpulse", "dracometeor", "dragonpulse", "earthpower", "fireblast", "nastyplot", "protect", "tailwind"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		randomBattleMoves: ["bugbuzz", "fireblast", "gigadrain", "quiverdance", "roost"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["bugbuzz", "gigadrain", "heatwave", "protect", "quiverdance"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	cobalion: {
		randomBattleMoves: ["closecombat", "ironhead", "stealthrock", "stoneedge", "swordsdance", "voltswitch"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["closecombat", "ironhead", "protect", "stoneedge", "swordsdance", "thunderwave"],
		randomDoubleBattleLevel: 84,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	terrakion: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "stoneedge", "swordsdance"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["closecombat", "protect", "rockslide", "swordsdance"],
		randomDoubleBattleLevel: 80,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	virizion: {
		randomBattleMoves: ["closecombat", "leafblade", "stoneedge", "swordsdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "coaching", "leafblade", "protect", "stoneedge", "swordsdance"],
		randomDoubleBattleLevel: 86,
		randomBattleNoDynamaxMoves: ["closecombat", "leafblade", "stoneedge", "swordsdance"],
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tornadus: {
		randomBattleMoves: ["defog", "grassknot", "heatwave", "hurricane", "nastyplot"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["heatwave", "hurricane", "nastyplot", "superpower", "tailwind", "taunt"],
		randomDoubleBattleLevel: 80,
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	tornadustherian: {
		randomBattleMoves: ["defog", "hurricane", "knockoff", "superpower", "uturn"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["heatwave", "hurricane", "knockoff", "nastyplot", "protect", "uturn"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	thundurus: {
		randomBattleMoves: ["grassknot", "knockoff", "nastyplot", "sludgewave", "superpower", "thunderbolt", "thunderwave"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["grassknot", "knockoff", "nastyplot", "protect", "sludgebomb", "thunderbolt", "thunderwave"],
		randomDoubleBattleLevel: 82,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	thundurustherian: {
		randomBattleMoves: ["focusblast", "grassknot", "nastyplot", "psychic", "thunderbolt", "voltswitch"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["agility", "focusblast", "grassknot", "nastyplot", "sludgebomb", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 82,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	reshiram: {
		randomBattleMoves: ["blueflare", "defog", "dracometeor", "earthpower", "roost", "stoneedge", "toxic"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["blueflare", "dracometeor", "earthpower", "heatwave", "roost", "tailwind"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zekrom: {
		randomBattleMoves: ["boltstrike", "dragondance", "outrage", "roost"],
		randomBattleLevel: 69,
		randomDoubleBattleMoves: ["boltstrike", "dragonclaw", "dragondance", "roost"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	landorus: {
		randomBattleMoves: ["earthpower", "focusblast", "knockoff", "rockpolish", "rockslide", "sludgewave", "stealthrock"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["calmmind", "earthpower", "focusblast", "protect", "psychic", "sludgebomb"],
		randomDoubleBattleLevel: 80,
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	landorustherian: {
		randomBattleMoves: ["earthquake", "fly", "stealthrock", "stoneedge", "swordsdance", "uturn"],
		randomBattleLevel: 72,
		randomDoubleBattleMoves: ["earthquake", "fly", "knockoff", "stoneedge", "swordsdance", "uturn"],
		randomDoubleBattleLevel: 76,
		randomBattleNoDynamaxMoves: ["earthquake", "knockoff", "stealthrock", "stoneedge", "swordsdance", "uturn"],
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	kyurem: {
		randomBattleMoves: ["dracometeor", "earthpower", "freezedry", "icebeam", "roost", "substitute"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["dracometeor", "earthpower", "freezedry", "glaciate", "protect", "roost"],
		randomDoubleBattleLevel: 78,
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	kyuremblack: {
		randomBattleMoves: ["dragondance", "fusionbolt", "iciclespear", "outrage"],
		randomBattleLevel: 73,
		randomDoubleBattleMoves: ["dragonclaw", "dragondance", "fusionbolt", "iciclespear", "protect"],
		randomDoubleBattleLevel: 75,
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	kyuremwhite: {
		randomBattleMoves: ["dracometeor", "earthpower", "freezedry", "fusionflare", "icebeam", "roost"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "earthpower", "freezedry", "fusionflare", "icebeam", "protect", "roost"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	keldeo: {
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	keldeoresolute: {
		randomBattleMoves: ["airslash", "calmmind", "hydropump", "icywind", "scald", "secretsword", "substitute"],
		randomBattleLevel: 79,
		randomDoubleBattleMoves: ["airslash", "calmmind", "icywind", "muddywater", "protect", "secretsword"],
		randomDoubleBattleLevel: 82,
	},
	meloetta: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	meloettapirouette: {
		isNonstandard: "Past",
	},
	genesect: {
		randomBattleMoves: ["blazekick", "extremespeed", "ironhead", "leechlife", "shiftgear", "thunderbolt", "uturn"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["blazekick", "ironhead", "leechlife", "protect", "shiftgear", "thunderbolt", "uturn"],
		randomDoubleBattleLevel: 78,
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectdouse: {
		randomBattleMoves: ["bugbuzz", "extremespeed", "flamethrower", "icebeam", "ironhead", "technoblast", "thunderbolt", "uturn"],
		randomBattleLevel: 74,
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	chespin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	quilladin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	chesnaught: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	fennekin: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	braixen: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	delphox: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	froakie: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	frogadier: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	greninja: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	greninjaash: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	bunnelby: {
		tier: "LC",
	},
	diggersby: {
		randomBattleMoves: ["bodyslam", "earthquake", "knockoff", "quickattack", "swordsdance", "uturn"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["bodyslam", "highhorsepower", "knockoff", "quickattack", "swordsdance", "uturn"],
		randomDoubleBattleLevel: 86,
		tier: "RUBL",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "NFE",
	},
	talonflame: {
		randomBattleMoves: ["bravebird", "defog", "flareblitz", "roost", "swordsdance", "uturn"],
		randomBattleLevel: 81,
		randomDoubleBattleMoves: ["bravebird", "defog", "incinerate", "overheat", "tailwind", "u-turn", "willowisp"],
		randomDoubleBattleLevel: 86,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	scatterbug: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	spewpa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	vivillon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	vivillonfancy: {
		isNonstandard: "Past",
	},
	vivillonpokeball: {
		isNonstandard: "Past",
	},
	litleo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	pyroar: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	flabebe: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	floette: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	floetteeternal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	florges: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	skiddo: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gogoat: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	pancham: {
		tier: "LC",
	},
	pangoro: {
		randomBattleMoves: ["closecombat", "gunkshot", "icepunch", "knockoff", "partingshot"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "drainpunch", "gunkshot", "icepunch", "knockoff", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	furfrou: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		randomBattleMoves: ["lightscreen", "psychic", "reflect", "thunderwave", "yawn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["fakeout", "lightscreen", "psychic", "reflect", "thunderwave"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	meowsticf: {
		randomBattleMoves: ["energyball", "nastyplot", "psychic", "shadowball", "thunderbolt"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["fakeout", "nastyplot", "psychic", "shadowball", "thunderbolt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	honedge: {
		tier: "LC",
	},
	doublade: {
		randomBattleMoves: ["closecombat", "ironhead", "shadowclaw", "shadowsneak", "swordsdance"],
		randomBattleLevel: 82,
		tier: "PU",
		doublesTier: "NFE",
		natDexTier: "NFE",
	},
	aegislash: {
		randomBattleMoves: ["closecombat", "flashcannon", "kingsshield", "shadowball", "shadowsneak", "substitute", "toxic"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["flashcannon", "kingsshield", "shadowball", "shadowsneak"],
		randomDoubleBattleLevel: 84,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	aegislashblade: {
		randomBattleMoves: ["closecombat", "ironhead", "shadowclaw", "shadowsneak", "swordsdance"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["closecombat", "ironhead", "kingsshield", "shadowclaw", "shadowsneak", "swordsdance"],
		randomDoubleBattleLevel: 84,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	spritzee: {
		tier: "LC",
	},
	aromatisse: {
		randomBattleMoves: ["calmmind", "moonblast", "protect", "toxic", "wish"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["healpulse", "moonblast", "protect", "trickroom", "wish"],
		randomDoubleBattleLevel: 86,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	swirlix: {
		tier: "NFE",
		natDexTier: "LC",
	},
	slurpuff: {
		randomBattleMoves: ["bellydrum", "drainpunch", "facade", "playrough"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["faketears", "flamethrower", "helpinghand", "playrough", "stickyweb"],
		randomDoubleBattleLevel: 86,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		randomBattleMoves: ["knockoff", "psychocut", "rest", "sleeptalk", "substitute", "superpower"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["knockoff", "psychocut", "rest", "superpower"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	binacle: {
		tier: "LC",
	},
	barbaracle: {
		randomBattleMoves: ["crosschop", "earthquake", "liquidation", "shellsmash", "stoneedge"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["liquidation", "protect", "rockslide", "shellsmash", "superpower"],
		randomDoubleBattleLevel: 84,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		randomBattleMoves: ["dracometeor", "dragonpulse", "flipturn", "focusblast", "sludgewave", "toxicspikes"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "focusblast", "protect", "sludgebomb"],
		randomDoubleBattleLevel: 86,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		randomBattleMoves: ["aurasphere", "darkpulse", "icebeam", "scald", "uturn", "waterpulse"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["aurasphere", "darkpulse", "icebeam", "muddywater", "uturn"],
		randomDoubleBattleLevel: 84,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	helioptile: {
		tier: "LC",
	},
	heliolisk: {
		randomBattleMoves: ["glare", "grassknot", "hypervoice", "surf", "thunderbolt", "voltswitch"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["glare", "grassknot", "hypervoice", "protect", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	tyrunt: {
		tier: "LC",
	},
	tyrantrum: {
		randomBattleMoves: ["closecombat", "dragondance", "earthquake", "headsmash", "outrage"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "dragonclaw", "dragondance", "headsmash", "highhorsepower"],
		randomDoubleBattleLevel: 86,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	amaura: {
		tier: "LC",
	},
	aurorus: {
		randomBattleMoves: ["ancientpower", "blizzard", "earthpower", "freezedry", "stealthrock", "thunderwave"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["auroraveil", "blizzard", "earthpower", "freezedry", "protect", "thunderwave"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	hawlucha: {
		randomBattleMoves: ["bravebird", "closecombat", "roost", "stoneedge", "swordsdance", "throatchop"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["bravebird", "closecombat", "protect", "swordsdance"],
		randomDoubleBattleLevel: 80,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	dedenne: {
		randomBattleMoves: ["protect", "recycle", "thunderbolt", "toxic"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["eerieimpulse", "helpinghand", "nuzzle", "recycle", "superfang", "thunderbolt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	carbink: {
		randomBattleMoves: ["bodypress", "lightscreen", "moonblast", "reflect", "stealthrock"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["bodypress", "irondefense", "moonblast", "stealthrock"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	sliggoohisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	goodra: {
		randomBattleMoves: ["dracometeor", "earthquake", "fireblast", "powerwhip", "sludgebomb", "thunderbolt"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["breakingswipe", "dracometeor", "fireblast", "muddywater", "powerwhip", "protect", "sludgebomb", "thunderbolt"],
		randomDoubleBattleLevel: 85,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	goodrahisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	klefki: {
		randomBattleMoves: ["magnetrise", "playrough", "spikes", "thunderwave", "toxic"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["dazzlinggleam", "foulplay", "spikes", "thunderwave"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		randomBattleMoves: ["earthquake", "hornleech", "poltergeist", "rockslide", "trickroom", "woodhammer"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["poltergeist", "protect", "trickroom", "willowisp", "woodhammer"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pumpkaboo: {
		tier: "LC",
	},
	pumpkaboosmall: {
		tier: "LC",
	},
	pumpkaboolarge: {
		tier: "LC",
	},
	pumpkaboosuper: {
		tier: "LC",
	},
	gourgeist: {
		randomBattleMoves: ["poltergeist", "powerwhip", "shadowsneak", "synthesis", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["leechseed", "poltergeist", "powerwhip", "substitute", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gourgeistsmall: {
		randomBattleMoves: ["leechseed", "poltergeist", "powerwhip", "substitute", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["leechseed", "poltergeist", "powerwhip", "substitute", "willowisp"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gourgeistlarge: {
		randomBattleMoves: ["poltergeist", "powerwhip", "shadowsneak", "synthesis", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["poltergeist", "powerwhip", "protect", "shadowsneak", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gourgeistsuper: {
		randomBattleMoves: ["poltergeist", "powerwhip", "rockslide", "shadowsneak", "trickroom"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["poltergeist", "powerwhip", "protect", "shadowsneak", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		randomBattleMoves: ["avalanche", "bodypress", "curse", "rapidspin", "recover"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["avalanche", "bodypress", "curse", "highhorsepower", "protect", "recover"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	avalugghisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		randomBattleMoves: ["defog", "dracometeor", "flamethrower", "hurricane", "roost", "switcheroo"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["boomburst", "dracometeor", "flamethrower", "hurricane", "protect", "tailwind"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	xerneas: {
		randomBattleMoves: ["focusblast", "geomancy", "moonblast", "psyshock", "thunderbolt"],
		randomBattleLevel: 67,
		randomDoubleBattleMoves: ["dazzlinggleam", "focusblast", "geomancy", "moonblast", "thunderbolt"],
		randomDoubleBattleLevel: 70,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	xerneasneutral: {
		isNonstandard: "Custom", // can't be used in battle
		tier: "Illegal",
	},
	yveltal: {
		randomBattleMoves: ["defog", "heatwave", "knockoff", "oblivionwing", "roost", "suckerpunch", "taunt"],
		randomBattleLevel: 69,
		randomDoubleBattleMoves: ["darkpulse", "heatwave", "knockoff", "oblivionwing", "roost", "suckerpunch", "tailwind"],
		randomDoubleBattleLevel: 71,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zygarde: {
		randomBattleMoves: ["dragondance", "outrage", "substitute", "thousandarrows"],
		randomBattleLevel: 70,
		randomDoubleBattleMoves: ["coil", "dragondance", "extremespeed", "glare", "irontail", "thousandarrows"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	zygarde10: {
		randomBattleMoves: ["coil", "extremespeed", "irontail", "outrage", "thousandarrows"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["dragondance", "extremespeed", "irontail", "protect", "stoneedge", "thousandarrows"],
		randomDoubleBattleLevel: 77,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zygardecomplete: {
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	diancie: {
		randomBattleMoves: ["bodypress", "diamondstorm", "earthpower", "moonblast", "stealthrock", "toxic"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bodypress", "diamondstorm", "earthpower", "moonblast"],
		randomDoubleBattleLevel: 80,
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	dianciemega: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	hoopa: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	hoopaunbound: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "UUBL",
	},
	volcanion: {
		randomBattleMoves: ["defog", "earthpower", "flamethrower", "sludgebomb", "steameruption"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["earthpower", "heatwave", "protect", "sludgebomb", "steameruption"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	rowlet: {
		tier: "LC",
	},
	dartrix: {
		tier: "NFE",
	},
	decidueye: {
		randomBattleMoves: ["bravebird", "leafblade", "poltergeist", "roost", "shadowsneak", "swordsdance"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["bravebird", "leafblade", "protect", "shadowsneak", "spiritshackle", "swordsdance"],
		randomDoubleBattleLevel: 88,
		randomBattleNoDynamaxMoves: ["leafblade", "roost", "shadowsneak", "spiritshackle", "swordsdance", "uturn"],
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	decidueyehisui: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	litten: {
		tier: "LC",
	},
	torracat: {
		tier: "NFE",
	},
	incineroar: {
		randomBattleMoves: ["earthquake", "flareblitz", "knockoff", "partingshot", "uturn", "willowisp"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["fakeout", "flareblitz", "knockoff", "partingshot", "uturn"],
		randomDoubleBattleLevel: 80,
		tier: "RU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	popplio: {
		tier: "LC",
	},
	brionne: {
		tier: "NFE",
	},
	primarina: {
		randomBattleMoves: ["energyball", "hydropump", "moonblast", "psychic", "sparklingaria"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["dazzlinggleam", "flipturn", "hypervoice", "moonblast", "protect", "psychic"],
		randomDoubleBattleLevel: 82,
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	pikipek: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	trumbeak: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "NFE",
	},
	toucannon: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	yungoos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	gumshoos: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	gumshoostotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	grubbin: {
		tier: "LC",
	},
	charjabug: {
		tier: "NFE",
	},
	vikavolt: {
		randomBattleMoves: ["bugbuzz", "energyball", "roost", "stickyweb", "thunderbolt", "voltswitch"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bugbuzz", "energyball", "protect", "stickyweb", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	vikavolttotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	crabrawler: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "LC",
	},
	crabominable: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricorio: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricoriopompom: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricoriopau: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	oricoriosensu: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	cutiefly: {
		tier: "NFE",
		natDexTier: "LC",
	},
	ribombee: {
		randomBattleMoves: ["moonblast", "psychic", "stickyweb", "stunspore", "uturn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["helpinghand", "moonblast", "pollenpuff", "speedswap", "stickyweb", "tailwind"],
		randomDoubleBattleLevel: 84,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	ribombeetotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	rockruff: {
		tier: "LC",
	},
	rockruffdusk: {
		tier: "LC",
	},
	lycanroc: {
		randomBattleMoves: ["accelerock", "closecombat", "psychicfangs", "stoneedge", "swordsdance"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["accelerock", "closecombat", "drillrun", "protect", "rockslide", "swordsdance"],
		randomDoubleBattleLevel: 84,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocmidnight: {
		randomBattleMoves: ["closecombat", "irontail", "stealthrock", "stoneedge", "suckerpunch", "swordsdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "irontail", "protect", "stoneedge", "suckerpunch", "swordsdance"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lycanrocdusk: {
		randomBattleMoves: ["accelerock", "closecombat", "psychicfangs", "stoneedge", "swordsdance"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["accelerock", "closecombat", "drillrun", "protect", "rockslide", "swordsdance"],
		randomDoubleBattleLevel: 81,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	wishiwashi: {
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wishiwashischool: {
		randomBattleMoves: ["earthquake", "hydropump", "icebeam", "scald", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["earthquake", "helpinghand", "hydropump", "icebeam", "muddywater", "protect"],
		randomDoubleBattleLevel: 88,
	},
	mareanie: {
		tier: "LC",
	},
	toxapex: {
		randomBattleMoves: ["banefulbunker", "haze", "recover", "scald", "toxic", "toxicspikes"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["banefulbunker", "haze", "recover", "scald", "toxic", "toxicspikes"],
		randomDoubleBattleLevel: 90,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	mudbray: {
		tier: "LC",
	},
	mudsdale: {
		randomBattleMoves: ["bodypress", "earthquake", "heavyslam", "rockslide", "stealthrock"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bodypress", "heavyslam", "highhorsepower", "protect", "rest", "rocktomb"],
		randomDoubleBattleLevel: 86,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dewpider: {
		tier: "LC",
	},
	araquanid: {
		randomBattleMoves: ["leechlife", "liquidation", "mirrorcoat", "stickyweb", "toxic"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["leechlife", "liquidation", "lunge", "protect", "stickyweb", "wideguard"],
		randomDoubleBattleLevel: 84,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	araquanidtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	fomantis: {
		tier: "LC",
	},
	lurantis: {
		randomBattleMoves: ["defog", "knockoff", "leafstorm", "superpower", "synthesis"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["defog", "knockoff", "leafstorm", "protect", "superpower"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	lurantistotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	morelull: {
		tier: "LC",
	},
	shiinotic: {
		randomBattleMoves: ["energyball", "leechseed", "moonblast", "spore", "strengthsap"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["energyball", "moonblast", "protect", "spore", "strengthsap"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	salandit: {
		tier: "LC",
	},
	salazzle: {
		randomBattleMoves: ["flamethrower", "protect", "substitute", "toxic"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["encore", "fakeout", "fireblast", "nastyplot", "protect", "sludgebomb"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	salazzletotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	stufful: {
		tier: "LC",
	},
	bewear: {
		randomBattleMoves: ["closecombat", "darkestlariat", "doubleedge", "icepunch", "swordsdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "darkestlariat", "doubleedge", "drainpunch", "icepunch", "protect", "wideguard"],
		randomDoubleBattleLevel: 88,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	bounsweet: {
		tier: "LC",
	},
	steenee: {
		tier: "NFE",
	},
	tsareena: {
		randomBattleMoves: ["highjumpkick", "knockoff", "powerwhip", "rapidspin", "synthesis", "tripleaxel", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["highjumpkick", "knockoff", "playrough", "powerwhip", "rapidspin", "tripleaxel", "uturn"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	comfey: {
		randomBattleMoves: ["calmmind", "drainingkiss", "gigadrain", "storedpower", "trick", "uturn"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["drainingkiss", "floralhealing", "gigadrain", "helpinghand", "protect"],
		randomDoubleBattleLevel: 89,
		tier: "PU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	oranguru: {
		randomBattleMoves: ["focusblast", "nastyplot", "psychic", "thunderbolt", "trickroom"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["allyswitch", "focusblast", "instruct", "psychic", "trickroom"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	passimian: {
		randomBattleMoves: ["closecombat", "earthquake", "gunkshot", "knockoff", "rockslide", "uturn"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "gunkshot", "knockoff", "rockslide", "uturn"],
		randomDoubleBattleLevel: 84,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wimpod: {
		tier: "LC",
	},
	golisopod: {
		randomBattleMoves: ["firstimpression", "knockoff", "leechlife", "liquidation", "spikes"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["aquajet", "firstimpression", "knockoff", "leechlife", "liquidation", "protect", "wideguard"],
		randomDoubleBattleLevel: 88,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandygast: {
		tier: "LC",
	},
	palossand: {
		randomBattleMoves: ["earthpower", "scorchingsands", "shadowball", "shoreup", "stealthrock", "toxic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["hypnosis", "protect", "scorchingsands", "shadowball", "shoreup", "stealthrock"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pyukumuku: {
		randomBattleMoves: ["counter", "mirrorcoat", "recover", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["helpinghand", "lightscreen", "memento", "reflect"],
		randomDoubleBattleLevel: 100,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	typenull: {
		randomBattleMoves: ["crushclaw", "payback", "rest", "sleeptalk", "swordsdance"],
		randomBattleLevel: 86,
		tier: "NFE",
	},
	silvally: {
		randomBattleMoves: ["crunch", "explosion", "flamecharge", "flamethrower", "multiattack", "swordsdance", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["crunch", "explosion", "flamethrower", "multiattack", "protect", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallybug: {
		randomBattleMoves: ["flamethrower", "multiattack", "partingshot", "psychicfangs", "thunderbolt"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "multiattack", "psychicfangs", "tailwind", "uturn"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallydark: {
		randomBattleMoves: ["ironhead", "multiattack", "partingshot", "psychicfangs", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["ironhead", "multiattack", "psychicfangs", "swordsdance", "tailwind"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallydragon: {
		randomBattleMoves: ["flamecharge", "ironhead", "multiattack", "partingshot", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["firefang", "ironhead", "multiattack", "swordsdance", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyelectric: {
		randomBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "grasspledge", "icebeam", "multiattack", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyfairy: {
		randomBattleMoves: ["flamecharge", "multiattack", "psychicfangs", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "multiattack", "partingshot", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyfighting: {
		randomBattleMoves: ["crunch", "ironhead", "multiattack", "swordsdance", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["crunch", "multiattack", "rockslide", "swordsdance", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyfire: {
		randomBattleMoves: ["crunch", "ironhead", "multiattack", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["heatwave", "icebeam", "multiattack", "tailwind", "thunderbolt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyflying: {
		randomBattleMoves: ["flamecharge", "ironhead", "multiattack", "rockslide", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["firefang", "ironhead", "multiattack", "swordsdance", "tailwind"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyghost: {
		randomBattleMoves: ["flamecharge", "multiattack", "partingshot", "swordsdance", "xscissor"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["multiattack", "swordsdance", "tailwind", "xscissor"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallygrass: {
		randomBattleMoves: ["defog", "flamethrower", "icebeam", "multiattack", "partingshot"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "icebeam", "multiattack", "partingshot", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyground: {
		randomBattleMoves: ["defog", "flamethrower", "icebeam", "multiattack", "partingshot", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["multiattack", "rockslide", "swordsdance", "tailwind"],
		randomDoubleBattleLevel: 89,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyice: {
		randomBattleMoves: ["flamecharge", "multiattack", "psychicfangs", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "multiattack", "partingshot", "tailwind", "thunderbolt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallypoison: {
		randomBattleMoves: ["defog", "flamethrower", "grasspledge", "multiattack", "partingshot", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "grasspledge", "multiattack", "partingshot", "snarl", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallypsychic: {
		randomBattleMoves: ["crunch", "multiattack", "swordsdance", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "multiattack", "partingshot", "tailwind", "xscissor"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallyrock: {
		randomBattleMoves: ["flamecharge", "multiattack", "partingshot", "psychicfangs", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "multiattack", "partingshot", "psychicfangs", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallysteel: {
		randomBattleMoves: ["defog", "flamethrower", "multiattack", "partingshot", "thunderbolt", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["flamethrower", "multiattack", "partingshot", "tailwind", "thunderbolt"],
		randomDoubleBattleLevel: 87,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	silvallywater: {
		randomBattleMoves: ["defog", "icebeam", "multiattack", "partingshot", "thunderbolt", "toxic"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["icebeam", "multiattack", "partingshot", "tailwind", "thunderbolt"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	minior: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	miniormeteor: {
		isNonstandard: "Past",
	},
	komala: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	turtonator: {
		randomBattleMoves: ["bodypress", "dracometeor", "earthquake", "fireblast", "rapidspin", "shellsmash", "willowisp"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["dragonpulse", "fireblast", "protect", "scorchingsands", "shellsmash"],
		randomDoubleBattleLevel: 84,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	togedemaru: {
		randomBattleMoves: ["ironhead", "nuzzle", "spikyshield", "uturn", "wish", "zingzap"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["encore", "fakeout", "ironhead", "nuzzle", "spikyshield", "zingzap"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	togedemarutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mimikyu: {
		randomBattleMoves: ["drainpunch", "playrough", "shadowclaw", "shadowsneak", "swordsdance"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["playrough", "shadowclaw", "shadowsneak", "swordsdance"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	mimikyutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	mimikyubustedtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	bruxish: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "RU",
	},
	drampa: {
		randomBattleMoves: ["dracometeor", "fireblast", "glare", "hypervoice", "roost", "thunderbolt"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["dracometeor", "dragonpulse", "heatwave", "hypervoice"],
		randomDoubleBattleLevel: 88,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dhelmise: {
		randomBattleMoves: ["anchorshot", "earthquake", "poltergeist", "powerwhip", "rapidspin", "swordsdance"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["anchorshot", "knockoff", "powerwhip", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	jangmoo: {
		tier: "LC",
	},
	hakamoo: {
		tier: "NFE",
	},
	kommoo: {
		randomBattleMoves: ["clangingscales", "clangoroussoul", "closecombat", "poisonjab", "stealthrock"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["bodypress", "dracometeor", "irondefense", "protect"],
		randomDoubleBattleLevel: 80,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	kommoototem: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "OU",
	},
	tapukoko: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "grassknot", "substitute", "thunderbolt", "voltswitch"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["bravebird", "dazzlinggleam", "grassknot", "taunt", "thunderbolt", "uturn"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	tapulele: {
		randomBattleMoves: ["calmmind", "focusblast", "moonblast", "psychic", "psyshock", "shadowball"],
		randomBattleLevel: 79,
		randomDoubleBattleMoves: ["calmmind", "dazzlinggleam", "focusblast", "moonblast", "protect", "psyshock"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	tapubulu: {
		randomBattleMoves: ["closecombat", "hornleech", "megahorn", "stoneedge", "swordsdance", "woodhammer"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "hornleech", "protect", "stoneedge", "swordsdance", "woodhammer"],
		randomDoubleBattleLevel: 83,
		tier: "UU",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	tapufini: {
		randomBattleMoves: ["calmmind", "defog", "moonblast", "surf", "taunt"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["haze", "healpulse", "moonblast", "muddywater", "naturesmadness", "protect", "taunt"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	cosmog: {
		tier: "LC",
	},
	cosmoem: {
		tier: "NFE",
	},
	solgaleo: {
		randomBattleMoves: ["closecombat", "flamecharge", "flareblitz", "knockoff", "psychicfangs", "sunsteelstrike"],
		randomBattleLevel: 72,
		randomDoubleBattleMoves: ["closecombat", "flareblitz", "morningsun", "protect", "psychicfangs", "stoneedge", "sunsteelstrike"],
		randomDoubleBattleLevel: 76,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	lunala: {
		randomBattleMoves: ["calmmind", "moonblast", "moongeistbeam", "psyshock", "roost"],
		randomBattleLevel: 72,
		randomDoubleBattleMoves: ["calmmind", "moonblast", "moongeistbeam", "protect", "psyshock", "roost"],
		randomDoubleBattleLevel: 74,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	nihilego: {
		randomBattleMoves: ["grassknot", "powergem", "sludgewave", "stealthrock", "thunderbolt", "toxicspikes"],
		randomBattleLevel: 79,
		randomDoubleBattleMoves: ["grassknot", "meteorbeam", "protect", "sludgebomb", "thunderbolt"],
		randomDoubleBattleLevel: 81,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "UU",
	},
	buzzwole: {
		randomBattleMoves: ["closecombat", "darkestlariat", "dualwingbeat", "ironhead", "leechlife", "stoneedge"],
		randomBattleLevel: 77,
		randomDoubleBattleMoves: ["closecombat", "darkestlariat", "dualwingbeat", "ironhead", "leechlife", "stoneedge"],
		randomDoubleBattleLevel: 80,
		randomBattleNoDynamaxMoves: ["bulkup", "closecombat", "darkestlariat", "leechlife", "poisonjab", "roost", "stoneedge"],
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	pheromosa: {
		randomBattleMoves: ["closecombat", "icebeam", "poisonjab", "throatchop", "uturn"],
		randomBattleLevel: 75,
		randomDoubleBattleMoves: ["closecombat", "icebeam", "poisonjab", "protect", "throatchop", "uturn"],
		randomDoubleBattleLevel: 78,
		tier: "Uber",
		doublesTier: "(DUU)",
		natDexTier: "Uber",
	},
	xurkitree: {
		randomBattleMoves: ["dazzlinggleam", "energyball", "hypnosis", "thunderbolt", "voltswitch"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["dazzlinggleam", "energyball", "thunderbolt", "voltswitch"],
		randomDoubleBattleLevel: 79,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	celesteela: {
		randomBattleMoves: ["airslash", "earthquake", "fireblast", "flashcannon", "leechseed", "protect"],
		randomBattleLevel: 77,
		randomDoubleBattleMoves: ["airslash", "fireblast", "flashcannon", "leechseed", "protect", "wideguard"],
		randomDoubleBattleLevel: 78,
		randomBattleNoDynamaxMoves: ["airslash", "earthquake", "fireblast", "heavyslam", "leechseed", "protect"],
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	kartana: {
		randomBattleMoves: ["knockoff", "leafblade", "sacredsword", "smartstrike", "swordsdance"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["knockoff", "leafblade", "sacredsword", "smartstrike", "swordsdance"],
		randomDoubleBattleLevel: 78,
		tier: "OU",
		doublesTier: "DUber",
		natDexTier: "OU",
	},
	guzzlord: {
		randomBattleMoves: ["darkpulse", "dracometeor", "fireblast", "knockoff", "sludgebomb"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["dracometeor", "fireblast", "knockoff", "protect", "sludgebomb"],
		randomDoubleBattleLevel: 88,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	necrozma: {
		randomBattleMoves: ["calmmind", "heatwave", "moonlight", "photongeyser", "stealthrock"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["calmmind", "earthpower", "heatwave", "moonlight", "photongeyser", "protect"],
		randomDoubleBattleLevel: 80,
		tier: "RUBL",
		doublesTier: "DOU",
		natDexTier: "RUBL",
	},
	necrozmaduskmane: {
		randomBattleMoves: ["dragondance", "earthquake", "morningsun", "photongeyser", "sunsteelstrike"],
		randomBattleLevel: 67,
		randomDoubleBattleMoves: ["dragondance", "photongeyser", "protect", "sunsteelstrike"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	necrozmadawnwings: {
		randomBattleMoves: ["calmmind", "heatwave", "moongeistbeam", "photongeyser", "stealthrock"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["heatwave", "moongeistbeam", "photongeyser", "protect", "thunderwave"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	necrozmaultra: {
		isNonstandard: "Past",
		tier: "Illegal",
		natDexTier: "Uber",
	},
	magearna: {
		randomBattleMoves: ["agility", "calmmind", "flashcannon", "fleurcannon"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["agility", "aurasphere", "dazzlinggleam", "flashcannon", "fleurcannon", "protect", "trick"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	magearnaoriginal: {
		randomBattleMoves: ["agility", "calmmind", "flashcannon", "fleurcannon"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["agility", "aurasphere", "dazzlinggleam", "flashcannon", "fleurcannon", "protect", "trick"],
		randomDoubleBattleLevel: 72,
	},
	marshadow: {
		randomBattleMoves: ["bulkup", "closecombat", "icepunch", "rocktomb", "shadowsneak", "spectralthief"],
		randomBattleLevel: 70,
		randomDoubleBattleMoves: ["closecombat", "protect", "rocktomb", "shadowsneak", "spectralthief"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	poipole: {
		tier: "NFE",
	},
	naganadel: {
		randomBattleMoves: ["airslash", "dracometeor", "fireblast", "nastyplot", "sludgewave"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["dracometeor", "flamethrower", "nastyplot", "sludgebomb", "uturn"],
		randomDoubleBattleLevel: 76,
		randomBattleNoDynamaxMoves: ["dracometeor", "fireblast", "nastyplot", "sludgewave", "uturn"],
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	stakataka: {
		randomBattleMoves: ["bodypress", "earthquake", "gyroball", "stealthrock", "stoneedge", "trickroom"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["bodypress", "gyroball", "highhorsepower", "rockslide", "trickroom"],
		randomDoubleBattleLevel: 82,
		tier: "NU",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	blacephalon: {
		randomBattleMoves: ["calmmind", "fireblast", "psyshock", "shadowball", "trick"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["fireblast", "protect", "psyshock", "shadowball", "trick"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "UUBL",
	},
	zeraora: {
		randomBattleMoves: ["blazekick", "bulkup", "closecombat", "grassknot", "knockoff", "plasmafists", "playrough", "voltswitch"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["closecombat", "fakeout", "grassknot", "knockoff", "plasmafists", "snarl"],
		randomDoubleBattleLevel: 78,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	meltan: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	melmetal: {
		randomBattleMoves: ["doubleironbash", "earthquake", "superpower", "thunderpunch", "thunderwave"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["acidarmor", "bodypress", "doubleironbash", "protect", "thunderpunch", "thunderwave"],
		randomDoubleBattleLevel: 76,
		tier: "OU",
		doublesTier: "DUber",
		natDexTier: "UUBL",
	},
	melmetalgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	grookey: {
		tier: "LC",
	},
	thwackey: {
		tier: "NFE",
	},
	rillaboom: {
		randomBattleMoves: ["grassyglide", "highhorsepower", "knockoff", "uturn", "woodhammer"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["fakeout", "grassyglide", "highhorsepower", "protect", "uturn", "woodhammer"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "OU",
	},
	rillaboomgmax: {
		randomBattleMoves: ["acrobatics", "grassyglide", "highhorsepower", "knockoff", "swordsdance"],
		randomBattleLevel: 78,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	scorbunny: {
		tier: "LC",
	},
	raboot: {
		tier: "NFE",
	},
	cinderace: {
		randomBattleMoves: ["courtchange", "gunkshot", "highjumpkick", "pyroball", "uturn", "zenheadbutt"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["courtchange", "gunkshot", "highjumpkick", "protect", "pyroball", "suckerpunch", "uturn"],
		randomDoubleBattleLevel: 80,
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	cinderacegmax: {
		randomBattleLevel: 74,
		randomBattleMoves: ["bulkup", "highjumpkick", "pyroball", "suckerpunch"],
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	sobble: {
		tier: "LC",
	},
	drizzile: {
		tier: "NFE",
	},
	inteleon: {
		randomBattleMoves: ["airslash", "darkpulse", "hydropump", "icebeam", "scald", "uturn"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["airslash", "hydropump", "icebeam", "muddywater", "uturn"],
		randomDoubleBattleLevel: 84,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	inteleongmax: {
		randomBattleMoves: ["airslash", "focusenergy", "icebeam", "surf"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["focusenergy", "hydropump", "icebeam", "muddywater"],
		randomDoubleBattleLevel: 84,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	skwovet: {
		tier: "LC",
	},
	greedent: {
		randomBattleMoves: ["bodyslam", "earthquake", "firefang", "payback", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bodyslam", "gyroball", "protect", "stompingtantrum", "swordsdance"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rookidee: {
		tier: "LC",
	},
	corvisquire: {
		tier: "NFE",
	},
	corviknight: {
		randomBattleMoves: ["bodypress", "bravebird", "bulkup", "defog", "roost"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["bodypress", "bravebird", "bulkup", "roost", "tailwind"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "OU",
	},
	corviknightgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	blipbug: {
		tier: "LC",
	},
	dottler: {
		tier: "NFE",
	},
	orbeetle: {
		randomBattleMoves: ["bodypress", "bugbuzz", "calmmind", "psychic", "recover", "stickyweb", "uturn"],
		randomBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	orbeetlegmax: {
		randomDoubleBattleMoves: ["helpinghand", "hypnosis", "lightscreen", "psychic", "reflect", "stickyweb", "strugglebug"],
		randomDoubleBattleLevel: 88,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	nickit: {
		tier: "LC",
	},
	thievul: {
		randomBattleMoves: ["darkpulse", "foulplay", "grassknot", "nastyplot", "partingshot", "psychic"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["faketears", "foulplay", "partingshot", "snarl", "taunt"],
		randomDoubleBattleLevel: 89,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	gossifleur: {
		tier: "LC",
	},
	eldegoss: {
		randomBattleMoves: ["energyball", "leechseed", "pollenpuff", "rapidspin", "sleeppowder"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["charm", "energyball", "helpinghand", "pollenpuff", "protect", "sleeppowder"],
		randomDoubleBattleLevel: 90,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	wooloo: {
		tier: "LC",
	},
	dubwool: {
		randomBattleMoves: ["bodypress", "cottonguard", "rest", "sleeptalk"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["doubleedge", "swordsdance", "thunderwave", "wildcharge", "zenheadbutt"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	chewtle: {
		tier: "LC",
	},
	drednaw: {
		randomBattleMoves: ["liquidation", "stealthrock", "stoneedge", "superpower", "swordsdance"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["highhorsepower", "liquidation", "protect", "rockslide", "superpower", "swordsdance"],
		randomDoubleBattleLevel: 84,
		randomBattleNoDynamaxMoves: ["liquidation", "raindance", "stealthrock", "stoneedge", "superpower"],
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	drednawgmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	yamper: {
		tier: "LC",
	},
	boltund: {
		randomBattleMoves: ["bulkup", "crunch", "firefang", "playrough", "psychicfangs", "thunderfang", "voltswitch"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["crunch", "firefang", "nuzzle", "playrough", "protect", "psychicfangs", "snarl", "thunderfang"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	rolycoly: {
		tier: "LC",
	},
	carkol: {
		tier: "NFE",
	},
	coalossal: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	coalossalgmax: {
		randomBattleMoves: ["overheat", "rapidspin", "spikes", "stealthrock", "stoneedge", "willowisp"],
		randomBattleLevel: 87,
		randomDoubleBattleMoves: ["fireblast", "incinerate", "protect", "stealthrock", "stoneedge", "willowisp"],
		randomDoubleBattleLevel: 85,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	applin: {
		tier: "LC",
	},
	flapple: {
		randomBattleMoves: ["dragondance", "gravapple", "outrage", "suckerpunch", "uturn"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["acrobatics", "dragondance", "dragonrush", "gravapple", "protect"],
		randomDoubleBattleLevel: 89,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	flapplegmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	appletun: {
		randomBattleMoves: ["appleacid", "dragonpulse", "leechseed", "recover"],
		randomBattleLevel: 90,
		randomDoubleBattleMoves: ["appleacid", "dragonpulse", "leechseed", "protect", "recover"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	appletungmax: {
		randomBattleMoves: ["appleacid", "dracometeor", "leechseed", "recover"],
		randomBattleLevel: 90,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	silicobra: {
		tier: "LC",
	},
	sandaconda: {
		randomBattleMoves: ["coil", "earthquake", "glare", "rest", "stealthrock", "stoneedge"],
		randomBattleLevel: 84,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sandacondagmax: {
		randomDoubleBattleMoves: ["coil", "glare", "highhorsepower", "protect", "stoneedge"],
		randomDoubleBattleLevel: 86,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	cramorant: {
		randomBattleMoves: ["bravebird", "defog", "roost", "superpower", "surf"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bravebird", "icebeam", "protect", "roost", "surf", "tailwind"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cramorantgulping: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cramorantgorging: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	arrokuda: {
		tier: "LC",
	},
	barraskewda: {
		randomBattleMoves: ["closecombat", "crunch", "liquidation", "poisonjab", "psychicfangs"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["closecombat", "drillrun", "flipturn", "liquidation", "poisonjab"],
		randomDoubleBattleLevel: 84,
		tier: "OU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxel: {
		tier: "LC",
	},
	toxtricity: {
		randomBattleMoves: ["boomburst", "overdrive", "shiftgear", "sludgewave", "voltswitch"],
		randomBattleLevel: 82,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxtricitylowkey: {
		randomBattleMoves: ["boomburst", "overdrive", "sludgewave", "voltswitch"],
		randomBattleLevel: 82,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	toxtricitygmax: {
		randomDoubleBattleMoves: ["boomburst", "overdrive", "shiftgear", "sludgebomb", "snarl", "voltswitch"],
		randomDoubleBattleLevel: 84,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	toxtricitylowkeygmax: {
		randomDoubleBattleMoves: ["boomburst", "overdrive", "sludgebomb", "snarl", "voltswitch"],
		randomDoubleBattleLevel: 84,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	sizzlipede: {
		tier: "LC",
	},
	centiskorch: {
		randomBattleMoves: ["coil", "firelash", "knockoff", "leechlife", "powerwhip"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["coil", "firelash", "knockoff", "leechlife", "powerwhip", "protect"],
		randomDoubleBattleLevel: 89,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	centiskorchgmax: {
		randomDoubleBattleMoves: ["coil", "firelash", "knockoff", "leechlife", "powerwhip", "protect"],
		randomDoubleBattleLevel: 89,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	clobbopus: {
		tier: "LC",
	},
	grapploct: {
		randomBattleMoves: ["brutalswing", "bulkup", "drainpunch", "icepunch", "suckerpunch"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["closecombat", "coaching", "drainpunch", "icepunch", "octolock", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	sinistea: {
		tier: "LC",
	},
	sinisteaantique: {
		tier: "LC",
	},
	polteageist: {
		randomBattleMoves: ["gigadrain", "shadowball", "shellsmash", "storedpower", "strengthsap"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["gigadrain", "protect", "shadowball", "shellsmash", "storedpower"],
		randomDoubleBattleLevel: 84,
		tier: "RU",
		doublesTier: "(DUU)",
		natDexTier: "RUBL",
	},
	hatenna: {
		tier: "LC",
	},
	hattrem: {
		tier: "NFE",
	},
	hatterene: {
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	hatterenegmax: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "mysticalfire", "psychic", "psyshock", "trickroom"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["dazzlinggleam", "mysticalfire", "protect", "psychic", "trickroom"],
		randomDoubleBattleLevel: 80,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	impidimp: {
		tier: "LC",
	},
	morgrem: {
		tier: "NFE",
	},
	grimmsnarl: {
		randomBattleMoves: ["lightscreen", "reflect", "spiritbreak", "taunt", "thunderwave"],
		randomBattleLevel: 82,
		tier: "NU",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	grimmsnarlgmax: {
		randomBattleMoves: ["bulkup", "darkestlariat", "playrough", "rest", "suckerpunch", "trick"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["darkestlariat", "fakeout", "lightscreen", "reflect", "spiritbreak", "taunt", "thunderwave"],
		randomDoubleBattleLevel: 84,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	milcery: {
		tier: "LC",
	},
	alcremie: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	alcremiegmax: {
		randomBattleMoves: ["calmmind", "dazzlinggleam", "mysticalfire", "psychic", "recover"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["dazzlinggleam", "decorate", "mysticalfire", "protect", "recover"],
		randomDoubleBattleLevel: 85,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	falinks: {
		randomBattleMoves: ["closecombat", "noretreat", "poisonjab", "rockslide", "throatchop"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["closecombat", "noretreat", "poisonjab", "rockslide", "throatchop"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	pincurchin: {
		randomBattleMoves: ["risingvoltage", "scald", "spikes", "suckerpunch", "toxicspikes"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["acupressure", "protect", "risingvoltage", "scald", "suckerpunch"],
		randomDoubleBattleLevel: 90,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	snom: {
		tier: "LC",
	},
	frosmoth: {
		randomBattleMoves: ["bugbuzz", "gigadrain", "hurricane", "icebeam", "quiverdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bugbuzz", "gigadrain", "hurricane", "icebeam", "protect", "quiverdance", "wideguard"],
		randomDoubleBattleLevel: 88,
		tier: "PU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	stonjourner: {
		randomBattleMoves: ["earthquake", "heatcrash", "rockpolish", "stealthrock", "stoneedge"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["bodypress", "heatcrash", "heavyslam", "protect", "rockpolish", "stoneedge"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	eiscue: {
		randomBattleMoves: ["bellydrum", "iciclecrash", "liquidation", "substitute", "zenheadbutt"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["bellydrum", "iciclecrash", "liquidation", "protect"],
		randomDoubleBattleLevel: 86,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	indeedee: {
		randomBattleMoves: ["calmmind", "expandingforce", "hypervoice", "mysticalfire", "trick"],
		randomBattleLevel: 83,
		randomDoubleBattleMoves: ["encore", "expandingforce", "hypervoice", "mysticalfire", "protect", "trick"],
		randomDoubleBattleLevel: 80,
		tier: "NUBL",
		doublesTier: "DUU",
		natDexTier: "RU",
	},
	indeedeef: {
		randomBattleMoves: ["calmmind", "expandingforce", "healingwish", "hypervoice", "mysticalfire"],
		randomBattleLevel: 85,
		randomDoubleBattleMoves: ["expandingforce", "followme", "healpulse", "helpinghand", "protect"],
		randomDoubleBattleLevel: 80,
		tier: "NUBL",
		doublesTier: "DOU",
		natDexTier: "RU",
	},
	morpeko: {
		randomBattleMoves: ["aurawheel", "foulplay", "partingshot", "protect", "psychicfangs", "rapidspin"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["aurawheel", "fakeout", "partingshot", "protect", "rapidspin", "superfang"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	morpekohangry: {
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	cufant: {
		tier: "LC",
	},
	copperajah: {
		randomBattleMoves: ["earthquake", "ironhead", "playrough", "rockslide", "stealthrock"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["heatcrash", "highhorsepower", "ironhead", "playrough", "powerwhip", "protect", "stoneedge"],
		randomDoubleBattleLevel: 88,
		tier: "NU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	copperajahgmax: {
		randomBattleMoves: ["earthquake", "heatcrash", "heavyslam", "powerwhip", "stoneedge"],
		randomBattleLevel: 84,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	dracozolt: {
		randomBattleMoves: ["aerialace", "boltbeak", "earthquake", "lowkick", "outrage"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["aerialace", "boltbeak", "dragonclaw", "highhorsepower", "rockslide"],
		randomDoubleBattleLevel: 82,
		randomBattleNoDynamaxMoves: ["boltbeak", "dragonclaw", "earthquake", "outrage"],
		tier: "UUBL",
		doublesTier: "DUU",
		natDexTier: "RUBL",
	},
	arctozolt: {
		randomBattleMoves: ["boltbeak", "freezedry", "iciclecrash", "stompingtantrum", "thunderwave"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["blizzard", "boltbeak", "iciclecrash", "lowkick", "protect"],
		randomDoubleBattleLevel: 88,
		tier: "UUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	dracovish: {
		randomBattleMoves: ["crunch", "fishiousrend", "icefang", "lowkick", "psychicfangs"],
		randomBattleLevel: 80,
		randomDoubleBattleMoves: ["crunch", "dragonrush", "fishiousrend", "icefang", "psychicfangs"],
		randomDoubleBattleLevel: 78,
		tier: "Uber",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	arctovish: {
		randomBattleMoves: ["bodyslam", "fishiousrend", "freezedry", "iciclecrash", "psychicfangs"],
		randomBattleLevel: 86,
		randomDoubleBattleMoves: ["blizzard", "fishiousrend", "iciclecrash", "protect", "superfang"],
		randomDoubleBattleLevel: 88,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	duraludon: {
		randomBattleMoves: ["bodypress", "dracometeor", "flashcannon", "stealthrock", "thunderbolt"],
		randomBattleLevel: 84,
		randomDoubleBattleMoves: ["bodypress", "dracometeor", "dragonpulse", "flashcannon", "protect", "snarl", "thunderbolt"],
		randomDoubleBattleLevel: 87,
		tier: "PUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	duraludongmax: {
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	dreepy: {
		tier: "LC",
	},
	drakloak: {
		tier: "NFE",
	},
	dragapult: {
		randomBattleMoves: ["dracometeor", "fireblast", "shadowball", "thunderbolt", "uturn"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["dragondarts", "fireblast", "protect", "shadowball", "thunderbolt", "thunderwave"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "Uber",
	},
	zacian: {
		randomBattleMoves: ["closecombat", "crunch", "playrough", "psychicfangs", "swordsdance"],
		randomBattleLevel: 68,
		randomDoubleBattleMoves: ["closecombat", "crunch", "playrough", "protect", "psychicfangs", "swordsdance"],
		randomDoubleBattleLevel: 72,
		tier: "AG",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zaciancrowned: {
		randomBattleMoves: ["behemothblade", "closecombat", "crunch", "playrough", "psychicfangs", "swordsdance"],
		randomBattleLevel: 62,
		randomDoubleBattleMoves: ["behemothblade", "closecombat", "playrough", "protect", "psychicfangs", "swordsdance"],
		randomDoubleBattleLevel: 65,
		tier: "AG",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zamazenta: {
		randomBattleMoves: ["closecombat", "crunch", "psychicfangs", "wildcharge"],
		randomBattleLevel: 73,
		randomDoubleBattleMoves: ["closecombat", "crunch", "playrough", "protect", "psychicfangs"],
		randomDoubleBattleLevel: 74,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	zamazentacrowned: {
		randomBattleMoves: ["behemothbash", "closecombat", "crunch", "howl", "psychicfangs"],
		randomBattleLevel: 71,
		randomDoubleBattleMoves: ["behemothbash", "closecombat", "crunch", "howl", "protect"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	eternatus: {
		randomBattleMoves: ["dynamaxcannon", "flamethrower", "recover", "sludgewave", "toxic"],
		randomBattleLevel: 69,
		randomDoubleBattleMoves: ["cosmicpower", "dynamaxcannon", "flamethrower", "recover"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	eternatuseternamax: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	kubfu: {
		tier: "NFE",
	},
	urshifu: {
		randomBattleMoves: ["closecombat", "ironhead", "suckerpunch", "uturn", "wickedblow"],
		randomBattleLevel: 76,
		randomDoubleBattleMoves: ["closecombat", "ironhead", "protect", "suckerpunch", "wickedblow"],
		randomDoubleBattleLevel: 76,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	urshifurapidstrike: {
		randomBattleMoves: ["bulkup", "drainpunch", "substitute", "surgingstrikes"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["aquajet", "closecombat", "icepunch", "protect", "surgingstrikes", "uturn"],
		randomDoubleBattleLevel: 80,
		tier: "OU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	urshifugmax: {
		randomBattleMoves: ["bulkup", "drainpunch", "substitute", "wickedblow"],
		randomBattleLevel: 76,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	urshifurapidstrikegmax: {
		randomBattleMoves: ["bulkup", "closecombat", "icepunch", "surgingstrikes", "uturn"],
		randomBattleLevel: 78,
		isNonstandard: "Gigantamax",
		tier: "AG",
		doublesTier: "(DUber)",
		natDexTier: "(Uber)",
	},
	zarude: {
		randomBattleMoves: ["bulkup", "closecombat", "darkestlariat", "junglehealing", "powerwhip", "uturn"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["closecombat", "darkestlariat", "junglehealing", "powerwhip", "protect"],
		randomDoubleBattleLevel: 80,
		tier: "UU",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	zarudedada: {
		randomBattleMoves: ["bulkup", "closecombat", "darkestlariat", "junglehealing", "powerwhip", "uturn"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["closecombat", "darkestlariat", "junglehealing", "powerwhip", "protect"],
		randomDoubleBattleLevel: 80,
	},
	regieleki: {
		randomBattleMoves: ["explosion", "substitute", "thunderbolt", "voltswitch"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["electroweb", "extremespeed", "protect", "thundercage", "voltswitch"],
		randomDoubleBattleLevel: 82,
		randomBattleNoDynamaxMoves: ["explosion", "rapidspin", "thunderbolt", "voltswitch"],
		tier: "UU",
		doublesTier: "DOU",
		natDexTier: "UU",
	},
	regidrago: {
		randomBattleMoves: ["dracometeor", "dragondance", "firefang", "hammerarm", "outrage"],
		randomBattleLevel: 78,
		randomDoubleBattleMoves: ["crunch", "dragonclaw", "dragonenergy", "firefang"],
		randomDoubleBattleLevel: 78,
		tier: "NUBL",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	glastrier: {
		randomBattleMoves: ["closecombat", "highhorsepower", "iciclecrash", "swordsdance"],
		randomBattleLevel: 82,
		randomDoubleBattleMoves: ["closecombat", "highhorsepower", "iciclecrash", "protect"],
		randomDoubleBattleLevel: 82,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	spectrier: {
		randomBattleMoves: ["darkpulse", "nastyplot", "shadowball", "substitute"],
		randomBattleLevel: 74,
		randomDoubleBattleMoves: ["darkpulse", "nastyplot", "protect", "shadowball"],
		randomDoubleBattleLevel: 78,
		tier: "Uber",
		doublesTier: "DUU",
		natDexTier: "Uber",
	},
	calyrex: {
		randomBattleMoves: ["calmmind", "gigadrain", "leechseed", "psyshock", "substitute"],
		randomBattleLevel: 88,
		randomDoubleBattleMoves: ["helpinghand", "leafstorm", "pollenpuff", "protect"],
		randomDoubleBattleLevel: 94,
		tier: "(PU)",
		doublesTier: "(DUU)",
		natDexTier: "RU",
	},
	calyrexice: {
		randomBattleMoves: ["agility", "closecombat", "glaciallance", "highhorsepower", "trickroom"],
		randomBattleLevel: 72,
		randomDoubleBattleMoves: ["closecombat", "glaciallance", "highhorsepower", "swordsdance", "trickroom"],
		randomDoubleBattleLevel: 72,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	calyrexshadow: {
		randomBattleMoves: ["astralbarrage", "nastyplot", "pollenpuff", "psyshock", "substitute", "trick"],
		randomBattleLevel: 65,
		randomDoubleBattleMoves: ["astralbarrage", "nastyplot", "pollenpuff", "protect", "psyshock"],
		randomDoubleBattleLevel: 68,
		tier: "Uber",
		doublesTier: "DUber",
		natDexTier: "Uber",
	},
	wyrdeer: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	kleavor: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	ursaluna: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	basculegion: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	basculegionf: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sneasler: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	overqwil: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	enamorus: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	enamorustherian: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	missingno: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	syclar: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	syclant: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	revenankh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	embirch: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	flarelm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	pyroak: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	breezi: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	fidgit: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	rebble: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tactite: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	stratagem: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	privatyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	arghonaut: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	nohface: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kitsunoh: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	monohm: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	duohm: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	cyclohm: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	dorsoil: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	colossoil: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	protowatt: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	krilowatt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	voodoll: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	voodoom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	scratchet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	tomohawk: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	necturine: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	necturna: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mollux: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cupra: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	argalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	aurumoth: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	brattler: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	malaconda: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	cawdet: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	cawmodore: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	volkritter: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	volkraken: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	snugglow: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	plasmanta: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	floatoy: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	caimanoe: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	naviathan: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibelle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	crucibellemega: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pluffle: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	kerfluffle: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pajantom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	mumbao: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	jumbao: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	fawnifer: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	electrelk: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	caribolt: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	smogecko: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	smoguana: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	smokomodo: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	swirlpool: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	coribalis: {
		isNonstandard: "CAP",
		tier: "CAP NFE",
	},
	snaelstrom: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	justyke: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	equilibra: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	solotl: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	astrolotl: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	miasmite: {
		isNonstandard: "CAP",
		tier: "CAP LC",
	},
	miasmaw: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	chromera: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomicon: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	venomiconepilogue: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	saharaja: {
		isNonstandard: "CAP",
		tier: "CAP",
	},
	pokestarsmeargle: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufo2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarbrycenman: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmt2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestartransport: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiant: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiant2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarhumanoid: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarmonster: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf00: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarf002: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarspirit: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackdoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarwhitedoor: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarblackbelt: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestargiantpropo2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
	pokestarufopropu2: {
		isNonstandard: "Custom",
		tier: "Illegal",
	},
};
